<template>
  <div class="users-list" >
    <!-- Cabeçalho simples (direto na página) -->
    <div class="lv-flex lv-items-center lv-gap-3 lv-mb-4" style="padding: 0.75rem 1rem 0 1.5rem;">
      <div class="lv-p-2 lv-rounded-lg lv-bg-gray-700">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-5 lv-w-5" style="color: white;">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        </div>
      <div>
        <h1 class="lv-text-xl lv-font-semibold lv-text-gray-800" style="margin: 0;">Usuários</h1>
        <p class="lv-text-sm lv-text-gray-500" style="margin: 0;">
          Gerencie os usuários da sua equipe<span v-if="isUnlimited && showBillingColumns && cycleDisplay"> · Dados referentes ao ciclo: {{ cycleDisplay }}</span>
        </p>
      </div>
        </div>

    <!-- Cards de Resumo (direto na página) -->
    <div style="padding: 0 1.5rem 0.5rem 1.5rem;">
      <div class="lv-grid" :style="isUnlimited && showBillingColumns ? 'grid-template-columns: repeat(' + summaryCardsCount + ', 1fr); gap: 1rem; margin-bottom: 0.5rem;' : 'grid-template-columns: 1fr; gap: 1rem; margin-bottom: 0.5rem;'">
        <summary-card
          label="Usuários Ativos"
          :value="activeUsersCount"
          border-color="#2563eb"
          icon-background-color="#eff6ff">
          <template slot="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-5 lv-w-5" style="color: #2563eb;">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
          </template>
          <template v-if="showActiveUserLimitFooter" slot="footer">
            <p class="users-summary-upgrade-message">
              <span>
                {{ inviteEligibilitySummaryMessage }}
              </span>
              <a
                href="#"
                class="users-summary-upgrade-link"
                @click.prevent="goToSubscription">
                Quer expandir seu time? Veja as opções de upgrade. &rarr;
              </a>
            </p>
          </template>
        </summary-card>
        <summary-card
          v-if="isUnlimited && showBillingColumns && subscriptionNetValue !== null"
          label="Valor Mensal"
          :value="formatUserCurrency(subscriptionNetValue)"
          :subtitle="nextDueDate ? 'Próximo vencimento: ' + nextDueDate : ''"
          border-color="#10b981"
          icon-background-color="#ecfdf5"
          value-color="#10b981">
          <template slot="subtitle-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-3 lv-w-3">
              <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z"></path>
              <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8"></path>
              <path d="M12 17.5v-11"></path>
            </svg>
          </template>
          <template slot="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-5 lv-w-5" style="color: #10b981;">
              <rect width="20" height="12" x="2" y="6" rx="2"></rect>
              <circle cx="12" cy="12" r="2"></circle>
              <path d="M6 12h.01M18 12h.01"></path>
            </svg>
          </template>
        </summary-card>
        <summary-card
          v-if="isUnlimited && showBillingColumns && showConsumptionColumn"
          label="Consumo do Ciclo Atual"
          :value="totalConsumption === null ? '—' : totalConsumption + ' min'"
          :subtitle="totalConsumption === null ? 'Temporariamente indisponível' : 'Minutos consumidos até o momento'"
          border-color="#8b5cf6"
          icon-background-color="#f5f3ff"
          value-color="#8b5cf6">
          <template slot="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-5 lv-w-5" style="color: #8b5cf6;">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </template>
        </summary-card>
              </div>
            </div>

    <!-- Abas: as pessoas de um lado, o que é cobrado do outro. Só em conta com
         licenças desacopladas, onde licença e usuário deixam de ser a mesma coisa. -->
    <div v-if="canManageSeats && seatsLoaded" class="seats-tabs">
      <button
        type="button"
        class="seats-tab"
        :class="{ 'seats-tab--active': activeTab === 'users' }"
        @click="activeTab = 'users'">
        Usuários
      </button>
      <button
        type="button"
        class="seats-tab"
        :class="{ 'seats-tab--active': activeTab === 'licenses' }"
        @click="activeTab = 'licenses'">
        Licenças
      </button>
    </div>

    <seats-table
      v-if="showLicensesTab"
      :seats="paidSeats"
      :users="users"
      :pricing-list="pricingList"
      :pending-purchase="pendingSeatPurchase"
      @assign="openAssignSeat"
      @purchase="openPurchaseSeatsModal"
      @refresh="loadUsers" />

    <!-- Filtros de Distribuição (direto na página) -->
    <div v-if="isUnlimited && showBillingColumns && !showLicensesTab" style="padding: 0.5rem 1.5rem 0.5rem 1.5rem;">
      <div class="lv-flex lv-items-center lv-gap-2 lv-mb-2">
        <span class="lv-text-sm lv-text-gray-500">Distribuição:</span>
        <distribution-button
          v-for="plan in planDistribution"
          :key="plan.code"
          :plan="plan.name"
          :code="plan.code"
          :count="plan.count"
          :selected="isPlanFilterSelected(plan.code)"
          @click="togglePlan(plan.code)" />
            </div>
          </div>

    <!-- Card 1: Filtros e Botão (busca, filtros e convite são da lista de usuários) -->
    <div v-if="!showLicensesTab" class="lv-rounded-lg lv-border lv-text-card-foreground lv-p-3 lv-mb-4 lv-bg-white lv-shadow-sm" style="margin: 0 1.5rem 1rem 1.5rem; max-width: calc(100% - 3rem);">
      <div class="lv-flex lv-items-center lv-gap-3">
    <!-- Busca -->
    <div class="lv-relative lv-flex-1 lv-max-w-sm">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="lv-absolute"
        style="left: 0.75rem; top: 50%; transform: translateY(-50%);
              height: 1rem; width: 1rem; color: #9ca3af; pointer-events: none;">
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.3-4.3"></path>
      </svg>

              <input
                type="text"
        class="lv-flex lv-w-full lv-rounded-md lv-border lv-px-3 lv-py-2 lv-h-9 lv-bg-gray-100 lv-border-gray-200 lv-text-sm search-input"
        placeholder="Buscar por nome ou e-mail..."
        v-model="filters.search"
        @input="applyFilters"
        style="padding-left: 2.5rem; border: 1px solid #e5e7eb;" />
    </div>

        <!-- Filtro de Plano (dropdown controlado – badges, bolinhas, cumulativo) -->
        <div
          v-if="isUnlimited && showBillingColumns"
          ref="planFilterDropdownRef"
          class="dropdown dropdown--plan-filter"
          :class="{ 'dropdown--plan-filter-open': showPlanFilterDropdown }">
                <button
            class="inline-flex lv-items-center lv-justify-center lv-gap-2 lv-text-sm lv-font-medium lv-rounded-md lv-px-3 lv-h-9 filter-pill lv-text-gray-700"
            type="button"
            :id="'planFilterDropdown'"
            aria-haspopup="true"
            :aria-expanded="showPlanFilterDropdown"
            style="white-space: nowrap; background-color: #f9fafb;"
            @click.stop="togglePlanFilterOpen">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-4 lv-w-4 lv-mr-2">
              <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
            </svg>
            {{ planFilterLabel }}
          </button>
            <div
              class="dropdown-menu plan-filter-dropdown"
              :aria-labelledby="'planFilterDropdown'"
              style="border-radius: 0.75rem; padding: 0.5rem; min-width: 200px;"
              @click.stop>
              <div
                class="filter-dropdown-option d-flex align-items-center"
                @click="selectAllPlans">
                <span class="filter-dropdown-check filter-dropdown-check--blue" :class="{ 'filter-dropdown-check--checked': allPlansSelected }" aria-hidden="true">
                  <svg v-if="allPlansSelected" class="filter-dropdown-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span class="filter-dropdown-label">Todos os planos</span>
              </div>
              <div class="filter-dropdown-divider"></div>
              <div
                v-for="plan in pricingList"
                :key="plan.code"
                class="filter-dropdown-option d-flex align-items-center"
                @click="togglePlan(plan.code)">
                <span class="filter-dropdown-check filter-dropdown-check--blue" :class="{ 'filter-dropdown-check--checked': isPlanFilterSelected(plan.code) }" aria-hidden="true">
                  <svg v-if="isPlanFilterSelected(plan.code)" class="filter-dropdown-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <plan-badge :plan="plan.name" :code="plan.code" />
            </div>
          </div>
        </div>

        <!-- Filtro de Status (dropdown controlado – não fecha ao marcar/desmarcar) -->
        <div
          ref="statusFilterDropdownRef"
          class="dropdown dropdown--status-filter"
          :class="{ 'dropdown--status-filter-open': showStatusFilterDropdown }">
          <button
            class="inline-flex lv-items-center lv-justify-center lv-gap-2 lv-text-sm lv-font-medium lv-rounded-md lv-px-3 lv-h-9 filter-pill lv-text-gray-700"
                  type="button"
            :id="'statusFilterDropdown'"
            aria-haspopup="true"
            :aria-expanded="showStatusFilterDropdown"
            style="white-space: nowrap; background-color: #f9fafb;"
            @click.stop="toggleStatusFilterOpen">
            {{ statusFilterLabel }}
          </button>
            <div
              class="dropdown-menu status-filter-dropdown"
              :aria-labelledby="'statusFilterDropdown'"
              style="border-radius: 0.75rem; padding: 0.5rem; min-width: 220px;"
              @click.stop>
              <div
                class="filter-dropdown-option d-flex align-items-center"
                @click="selectAllStatuses">
                <span class="filter-dropdown-check filter-dropdown-check--blue" :class="{ 'filter-dropdown-check--checked': allStatusSelected }" aria-hidden="true">
                  <svg v-if="allStatusSelected" class="filter-dropdown-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
              </span>
                <span class="filter-dropdown-label">Todos os status</span>
        </div>
              <div class="filter-dropdown-divider"></div>
              <div
                class="filter-dropdown-option d-flex align-items-center"
                @click="toggleStatus('active')">
                <span class="filter-dropdown-check filter-dropdown-check--blue" :class="{ 'filter-dropdown-check--checked': filters.status.active }" aria-hidden="true">
                  <svg v-if="filters.status.active" class="filter-dropdown-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span class="status-tag status-tag-active">Ativo</span>
      </div>
              <div
                class="filter-dropdown-option d-flex align-items-center"
                @click="toggleStatus('inactive')">
                <span class="filter-dropdown-check filter-dropdown-check--blue" :class="{ 'filter-dropdown-check--checked': filters.status.inactive }" aria-hidden="true">
                  <svg v-if="filters.status.inactive" class="filter-dropdown-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span class="status-tag status-tag-inactive">Desativado</span>
    </div>
    <div
                v-if="isUnlimited && showBillingColumns"
                class="filter-dropdown-option d-flex align-items-center"
                @click="toggleStatus('awaiting_payment')">
                <span class="filter-dropdown-check filter-dropdown-check--blue" :class="{ 'filter-dropdown-check--checked': filters.status.awaitingPayment }" aria-hidden="true">
                  <svg v-if="filters.status.awaitingPayment" class="filter-dropdown-check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </span>
                <span class="status-tag status-tag-awaiting">Aguardando Pagamento</span>
              </div>
            </div>
          </div>

        <div style="flex: 1;"></div>

        <!-- Botão Convidar -->
            <button
        class="btn-invite-user inline-flex lv-items-center lv-justify-center lv-gap-3 lv-rounded-md lv-text-sm lv-font-medium lv-h-10 lv-px-8 lv-py-2 lv-bg-blue-600 lv-text-white lv-ml-auto"
        @click="openAddUserModal"
        style="white-space: nowrap; color: #ffffff; border: none; outline: none; padding-left: 1rem; border-radius: 0.575rem;">

        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#ffffff"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lv-h-4 lv-w-4"
          style="color: #ffffff;">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <line x1="19" x2="19" y1="8" y2="14"></line>
          <line x1="22" x2="16" y1="11" y2="11"></line>
        </svg>

        <span style="padding-right: 1rem;">Convidar novo usuário</span>
            </button>

          </div>
    </div>

    <!-- Card 2: Listagem -->
    <div v-if="!showLicensesTab" class="lv-rounded-lg lv-border lv-text-card-foreground lv-overflow-hidden lv-bg-white lv-shadow-sm" style="margin: 0 1.5rem 1.5rem 1.5rem; max-width: calc(100% - 3rem);">
      <ErrorAlert
        :error="error"
        :centered="true"
        style="margin: 1.5rem;" />

      <!-- Loading -->
      <div v-if="isLoading && !error" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Carregando...</span>
          </div>
      </div>

      <!-- Tabela de usuários -->
      <div v-if="!isLoading && !error" style="width: 100%; overflow: hidden;">
        <div class="lv-relative lv-w-full lv-overflow-auto" style="width: 100%; margin: 0; padding: 0;">
          <table class="lv-w-full lv-text-sm" style="caption-side: bottom; width: 100%; border-collapse: collapse;">
            <thead>
              <tr class="lv-bg-gray-100 lv-border-b lv-border-gray-200 transition-colors">
              <th class="lv-text-left lv-text-xs lv-font-semibold lv-text-gray-500 lv-uppercase lv-tracking-wide lv-cursor-pointer hover-bg-gray-100 transition-colors lv-select-none" style="vertical-align: middle; padding: 1rem 1rem 1rem 1rem; height: auto; color: #6b7280;" @click="sortBy('name')">
                <div class="lv-flex lv-items-center lv-gap-1">
                  Usuário
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-3 lv-w-3 lv-opacity-40">
                    <path d="m21 16-4 4-4-4"></path>
                    <path d="M17 20V4"></path>
                    <path d="m3 8 4-4 4 4"></path>
                    <path d="M7 4v16"></path>
                  </svg>
                </div>
              </th>
              <th v-if="!isUnlimited" class="lv-text-xs lv-font-semibold lv-text-gray-500 lv-uppercase lv-tracking-wide lv-text-center lv-cursor-pointer hover-bg-gray-100 transition-colors lv-select-none" style="vertical-align: middle; padding: 1rem 1rem 1rem 1rem; height: auto; color: #6b7280;" @click="sortBy('extension')">
                <div class="lv-flex lv-items-center lv-gap-1 lv-justify-center">
                  Ramal
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-3 lv-w-3 lv-opacity-40">
                    <path d="m21 16-4 4-4-4"></path>
                    <path d="M17 20V4"></path>
                    <path d="m3 8 4-4 4 4"></path>
                    <path d="M7 4v16"></path>
                  </svg>
                </div>
              </th>
              <th class="lv-text-xs lv-font-semibold lv-text-gray-500 lv-uppercase lv-tracking-wide lv-text-center lv-cursor-pointer hover-bg-gray-100 transition-colors lv-select-none" style="vertical-align: middle; padding: 1rem 1rem 1rem 1rem; height: auto; color: #6b7280;" @click="sortBy('status')">
                <div class="lv-flex lv-items-center lv-gap-1 lv-justify-center">
                  Status
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-3 lv-w-3 lv-opacity-40">
                    <path d="m21 16-4 4-4-4"></path>
                    <path d="M17 20V4"></path>
                    <path d="m3 8 4-4 4 4"></path>
                    <path d="M7 4v16"></path>
                  </svg>
                </div>
              </th>
              <th v-if="isUnlimited && showBillingColumns && showConsumptionColumn" class="lv-text-xs lv-font-semibold lv-text-gray-500 lv-uppercase lv-tracking-wide lv-text-center lv-cursor-pointer hover-bg-gray-100 transition-colors lv-select-none" style="vertical-align: middle; padding: 1rem 1rem 1rem 1rem; height: auto; color: #6b7280;" @click="sortBy('consumption')">
                <div class="inline-lv-flex lv-items-center lv-gap-1 lv-justify-center">
                  Consumo
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-3 lv-w-3 lv-opacity-40">
                    <path d="m21 16-4 4-4-4"></path>
                    <path d="M17 20V4"></path>
                    <path d="m3 8 4-4 4 4"></path>
                    <path d="M7 4v16"></path>
                  </svg>
                </div>
              </th>
              <th v-if="isUnlimited && showBillingColumns" class="lv-text-xs lv-font-semibold lv-text-gray-500 lv-uppercase lv-tracking-wide lv-text-center lv-cursor-pointer hover-bg-gray-100 transition-colors lv-select-none" style="vertical-align: middle; padding: 1rem 1rem 1rem 1rem; height: auto; color: #6b7280;" @click="sortBy('plan')">
                <div class="lv-flex lv-items-center lv-gap-1 lv-justify-center">
                  Plano
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-3 lv-w-3 lv-opacity-40">
                    <path d="m21 16-4 4-4-4"></path>
                    <path d="M17 20V4"></path>
                    <path d="m3 8 4-4 4 4"></path>
                    <path d="M7 4v16"></path>
                  </svg>
                </div>
              </th>
              <th v-if="isUnlimited && showBillingColumns && showValueColumn" class="lv-text-xs lv-font-semibold lv-text-gray-500 lv-uppercase lv-tracking-wide lv-cursor-pointer hover-bg-gray-100 transition-colors lv-select-none" style="vertical-align: middle; padding: 1rem 1rem 1rem 1rem; height: auto; text-align: right; color: #6b7280;" @click="sortBy('value')">
                <div class="lv-flex lv-items-center lv-gap-1 lv-justify-end">
                  Valor
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-3 lv-w-3 lv-opacity-40">
                    <path d="m21 16-4 4-4-4"></path>
                    <path d="M17 20V4"></path>
                    <path d="m3 8 4-4 4 4"></path>
                    <path d="M7 4v16"></path>
                  </svg>
                </div>
              </th>
              <th class="lv-text-left lv-font-medium lv-text-muted-foreground" style="vertical-align: middle; padding: 1rem 0 1rem 0.5rem; height: auto; width: 50px;"></th>
            </tr>
          </thead>
            <tbody>
              <tr v-if="sortedUsers.length === 0">
                <td :colspan="emptyStateColspan" class="text-center py-5" style="color: #6b7280;">
                  Nenhum usuário encontrado
                </td>
              </tr>
              <tr
                v-for="user in paginatedUsers"
                :key="user.id"
                class="hover-bg-gray-50 transition-colors user-row"
                :class="{
                  'user-row--awaiting': getStatusLabel(user) === 'Aguardando pagamento',
                  'user-row--inactive': getStatusLabel(user) === 'Desativado'
                }"
                style="border-bottom: 1px solid #e5e7eb;">
                <td class="lv-py-3" style="vertical-align: middle; padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem;">
                  <div class="lv-flex lv-items-center lv-gap-3">
                    <svg
                      v-if="user.role === 'ADMIN'"
                      class="lv-h-6 lv-w-6 lv-text-blue-600 lv-flex-shrink-0"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 24 24">
                      <path stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" stroke-width="2" d="M10 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2m10 1a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m3 3h1m-4 3a3 3 0 0 1-3-3m3 3v1m-3-4a3 3 0 0 1 3-3m-3 3h-1m4-3v-1m-2.121 1.879-.707-.707m5.656 5.656-.707-.707m-4.242 0-.707.707m5.656-5.656-.707.707M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                    </svg>
                    <svg
                      v-else
                      class="lv-h-6 lv-w-6 lv-text-gray-400 lv-flex-shrink-0"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 24 24">
                      <g transform="translate(-1, 0)">
                        <path stroke="currentColor" stroke-width="2" d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                      </g>
                    </svg>
                    <div class="lv-flex-1">
                      <div class="lv-flex lv-items-center lv-gap-2">
                        <span class="lv-font-medium lv-text-gray-800">{{ user.name || 'Sem nome' }}</span>
                        <span
                          v-if="hasPendingInvite(user)"
                          class="lv-inline-flex lv-items-center lv-gap-2 lv-px-2.5 lv-py-1.5 lv-rounded-xlg lv-text-xs lv-text-xs-10 lv-font-small"
                          style="background-color: #dbeafe; color: #2563eb; border: 1px solid #BCD6FE;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 28 26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0; margin-right: 2px;">
                            <rect width="24" height="20" x="2" y="4" rx="2"></rect>
                            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                          </svg>
                          Convite pendente
                        </span>
                      </div>
                      <div class="lv-text-xs lv-text-gray-500">{{ user.email }}</div>
                    </div>
                  </div>
                </td>
                <td v-if="!isUnlimited" class="lv-text-center lv-py-3" style="vertical-align: middle; padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem;">
                  <span class="lv-text-sm lv-font-medium lv-text-gray-800">
                    {{ getUserExtension(user) || '-' }}
                  </span>
                </td>
                <td class="lv-text-center lv-py-3" style="vertical-align: middle; padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem;">
                  <div class="lv-flex lv-items-center lv-justify-center">
                    <div
                      v-if="getStatusLabel(user) === 'Ativo'"
                      class="status-tag status-tag-active">
                      {{ getStatusLabel(user) }}
                    </div>
                    <div
                      v-else-if="getStatusLabel(user) === 'Aguardando pagamento'"
                      class="status-tag status-tag-awaiting status-tag-clickable"
                      role="button"
                      tabindex="0"
                      title="Ver histórico de cobranças"
                      @click.stop="goToChargeHistory"
                      @keydown.enter.stop="goToChargeHistory">
                      {{ getStatusLabel(user) }}
                    </div>
                    <div
                      v-else
                      class="status-tag status-tag-inactive">
                      {{ getStatusLabel(user) }}
                    </div>
                  </div>
                </td>
                <td v-if="isUnlimited && showBillingColumns && showConsumptionColumn" class="lv-text-center lv-py-3" style="vertical-align: middle; padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem;">
                  <div class="inline-lv-flex lv-items-center lv-gap-1">
                    <template v-if="userPlanData[user.id] && userConsumption[user.id] && userConsumption[user.id].current !== null && !isInactiveUser(user) && !isGerencialUser(user) && userConsumption[user.id].limit !== 0">
                      <span class="lv-text-sm lv-font-medium" :style="isOutOfMinutes(user) ? 'color: #b91c1c;' : 'color: #1f2937;'">
                        {{ userConsumption[user.id].current }} min
                      </span>
                      <span class="lv-text-xs lv-text-gray-400">
                        / {{ userConsumption[user.id].limit === null ? 'ilimitado' : userConsumption[user.id].limit + ' min' }}
                      </span>
                    </template>
                    <span v-else class="lv-text-sm lv-font-medium lv-text-gray-800">-</span>
                  </div>
                </td>
                <td v-if="isUnlimited && showBillingColumns" class="lv-text-center lv-py-3" style="vertical-align: middle; padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem;">
                  <plan-badge
                    v-if="userPlanData[user.id]"
                    :plan="userPlanData[user.id].plan"
                    :code="userPlanData[user.id].planCode" />
                  <plan-badge
                    v-else-if="isGerencialUser(user)"
                    :plan="gerencialPlanName"
                    :code="gerencialPlanCode" />
                  <span v-else class="lv-text-gray-400">-</span>
                </td>
                <td v-if="isUnlimited && showBillingColumns && showValueColumn" class="lv-py-3 lv-font-semibold lv-text-green-500 value-cell" style="vertical-align: middle; padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem; text-align: right;">
                  <span v-if="userPlanData[user.id]">
                    {{ userPlanData[user.id].value === 0 ? 'Grátis' : formatUserCurrency(userPlanData[user.id].value) }}
                  </span>
                  <span v-else-if="isGerencialUser(user)">Grátis</span>
                  <span v-else class="lv-text-gray-400">-</span>
                </td>
                <td class="lv-text-center lv-py-3 user-actions-cell" style="vertical-align: middle; padding-left: 0.5rem; padding-right: 0; padding-top: 0.75rem; padding-bottom: 0.75rem;">
                  <div class="dropdown user-actions-dropdown">
              <button
                      class="inline-lv-flex lv-items-center lv-justify-center lv-gap-2 lv-rounded-md lv-text-sm lv-font-medium lv-h-8 lv-w-8"
                type="button"
                      :id="'actions-' + user.id"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style="white-space: nowrap; background: transparent; border: none; color: #6b7280;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lv-h-4 lv-w-4 lv-text-gray-500">
                        <circle cx="12" cy="12" r="1"></circle>
                        <circle cx="19" cy="12" r="1"></circle>
                        <circle cx="5" cy="12" r="1"></circle>
                      </svg>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right user-actions-menu" :aria-labelledby="'actions-' + user.id">
                      <a v-if="!isCurrentUser(user)" class="dropdown-item d-flex align-items-center" href="#" @click.prevent="editUser(user)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 flex-shrink-0" aria-hidden="true">
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                        </svg>
                        Editar
                      </a>
                      <a class="dropdown-item d-flex align-items-center" href="#" @click.prevent="viewUserDetails(user)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 flex-shrink-0" aria-hidden="true">
                          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                          <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                        Ver detalhes
                      </a>
                      <a v-if="hasPendingInvite(user)" class="dropdown-item d-flex align-items-center" :class="{ disabled: resendingInviteEmail === user.email }" href="#" @click.prevent="resendInvite(user)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 flex-shrink-0" aria-hidden="true">
                          <path d="m22 2-7 20-4-9-9-4Z"></path>
                          <path d="M22 2 11 13"></path>
                        </svg>
                        Reenviar Convite
                      </a>
                      <a v-if="canTransferSeat(user)" class="dropdown-item d-flex align-items-center" href="#" @click.prevent="openTransferSeatModal(user)">
                        Transferir a licença
                      </a>
            </div>
          </div>
                </td>
              </tr>
              <!-- Linha de Total (apenas da página atual) -->
              <tr v-if="sortedUsers.length > 0" style="background-color: #eff6ff; border-top: 1px solid #e5e7eb;">
                <td class="lv-py-3" style="font-weight: 700; color: #000000; padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem; vertical-align: middle;">
                  TOTAL
                </td>
                <td v-if="!isUnlimited" class="lv-py-3" style="padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem; vertical-align: middle;">
                  <!-- Vazio (Ramal) -->
                </td>
                <td class="lv-py-3 lv-text-center" style="font-weight: 350; color: #000000; padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem; vertical-align: middle;">
                  {{ paginatedUsers.length }} usuários
                </td>
                <td v-if="isUnlimited && showBillingColumns && showConsumptionColumn" class="lv-py-3 lv-text-center" style="font-weight: 600; color: #2563eb; padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem; vertical-align: middle;">
                  {{ totalConsumptionPage === null ? '—' : totalConsumptionPage + ' min' }}
                </td>
                <td v-if="isUnlimited && showBillingColumns" class="lv-py-3" style="padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem; vertical-align: middle;">
                  <!-- Vazio -->
                </td>
                <td v-if="isUnlimited && showBillingColumns && showValueColumn" class="lv-py-3" style="font-weight: 700; color: #16a34a; padding-left: 1rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem; vertical-align: middle; text-align: right;">
                  {{ formatUserCurrency(totalValuePage) }}
                </td>
                <td class="lv-py-3" style="padding-left: 0.5rem; padding-right: 1rem; padding-top: 0.75rem; padding-bottom: 0.75rem; vertical-align: middle;">
                  <!-- Vazio -->
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Truncamento: só aparece quando a busca parou no teto de páginas. A tela precisa
             dizer que a lista pode estar incompleta — foi a ausência desse aviso que fez os
             96 usuários faltantes passarem por dado correto (TEL-2366). -->
        <div v-if="usersTruncated" class="alert alert-warning" style="margin: 0 1.5rem 1rem 1.5rem;">
          Esta conta tem mais usuários do que o portal consegue exibir de uma vez.
          Mostrando os primeiros {{ users.length }}, em ordem alfabética — a busca, os
          filtros e os totais abaixo se aplicam somente a eles.
        </div>

        <!-- Paginação -->
        <div v-if="sortedUsers.length > 0" class="pagination-container pagination-layout">
          <div class="per-page-selector">
            <label for="per-page-dropdown" class="per-page-label">Itens por página:</label>
            <select
              id="per-page-dropdown"
              v-model.number="perPage"
              class="per-page-dropdown"
              @change="onPerPageChange">
              <option v-for="n in perPageOptions" :key="n" :value="n">{{ n }}</option>
            </select>
      </div>
          <div class="pagination-center">
            Mostrando {{ (currentPage - 1) * perPage + 1 }} a {{ Math.min(currentPage * perPage, sortedUsers.length) }} de {{ sortedUsers.length }} usuários
    </div>
          <b-pagination
            v-model="currentPage"
            :total-rows="sortedUsers.length"
            :per-page="perPage"
            :limit="5"
            align="center" />
        </div>
      </div>
    </div>

    <!-- Modal de Convidar Usuário -->
    <add-user-modal
      :visible="showAddUserModal"
      :is-unlimited="isUnlimited"
      :pricing-list="pricingList"
      :vacant-seat-plan-codes="vacantSeatPlanCodes"
      :vacant-seat-expiry-by-plan-code="vacantSeatExpiryByPlanCode"
      @close="closeAddUserModal"
      @refresh-users="loadUsers" />

    <transfer-seat-modal
      v-if="seatTransferFrom"
      :candidates="seatCandidates"
      :transfer-from="seatTransferFrom"
      :sender-already-deactivated="seatTransferSenderDeactivated"
      @close="closeTransferSeatModal"
      @refresh="loadUsers" />

    <assign-seat-modal
      v-if="seatToAssign"
      :seat="seatToAssign"
      :candidates="seatCandidates"
      :pricing-list="pricingList"
      @close="seatToAssign = null"
      @assigned="loadUsers" />

    <purchase-seats-modal
      :visible="showPurchaseSeatsModal"
      :pricing-list="pricingList"
      @close="closePurchaseSeatsModal" />

    <user-limit-reached-modal
      :visible="showUserLimitReachedModal"
      :max-active-users="inviteEligibilityMaxUsers !== null ? inviteEligibilityMaxUsers : 0"
      :message="inviteEligibilityBlockMessage"
      @close="closeUserLimitReachedModal"
      @upgrade-click="handleUserLimitUpgradeClick" />

    <session-outdated-modal
      :visible="showSessionOutdatedModal"
      @confirm="confirmSessionOutdated" />

    <account-restricted-modal
      :visible="showAccountRestrictedModal"
      @close="showAccountRestrictedModal = false" />

    <!-- Modal de Detalhes do Usuário -->
    <div
      v-if="showDetailsModal && selectedUser"
      class="modal-overlay"
      @click.self="closeDetailsModal"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5); z-index: 1050; display: flex; align-items: center; justify-content: center;">
      <div
        role="dialog"
        class="user-details-modal"
        style="pointer-events: auto; max-width: 28rem; width: 88%; background: white; border-radius: 0.75rem; padding: 0; position: relative; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);">

        <!-- Header -->
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem 0.75rem 1.25rem;">
          <div style="display: flex; align-items: center; gap: 0.5rem;">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #374151;">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <h3 style="font-size: 1rem; font-weight: 700; margin: 0; color: #111827;">Detalhes do Usuário</h3>
          </div>
            <button
              type="button"
            style="background: transparent; border: none; cursor: pointer; padding: 0.25rem; display: flex; align-items: center; justify-content: center; color: #6b7280;"
            @click="closeDetailsModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
            </button>
          </div>

        <!-- Content -->
        <div style="padding: 1rem 1.25rem;">
          <!-- Profile Summary -->
          <div style="background-color: #f9fafb; border-radius: 0.5rem; padding: 0.75rem; margin-bottom: 1rem; display: flex; align-items: center; gap: 0.5rem;">
            <!-- Admin: ícone padrão user + engrenagem -->
            <div
              v-if="selectedUser.role === 'ADMIN'"
              style="width: 44px; height: 44px; background-color: #eff6ff; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <path stroke="#2563eb" stroke-linecap="square" stroke-linejoin="round" stroke-width="2" d="M10 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2m10 1a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m3 3h1m-4 3a3 3 0 0 1-3-3m3 3v1m-3-4a3 3 0 0 1 3-3m-3 3h-1m4-3v-1m-2.121 1.879-.707-.707m5.656 5.656-.707-.707m-4.242 0-.707.707m5.656-5.656-.707.707M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
              </svg>
            </div>
            <div
              v-else
              style="width: 44px; height: 44px; background-color: #f3f4f6; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
              <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                <g transform="translate(-1, 0)">
                  <path stroke="#6b7280" stroke-width="2" d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                </g>
              </svg>
            </div>
            <div>
              <div style="font-size: 0.9375rem; font-weight: 700; color: #111827; margin-bottom: 0.125rem;">{{ selectedUser.name || 'Sem nome' }}</div>
              <div style="font-size: 0.8125rem; color: #6b7280;">{{ getUserRole(selectedUser) }}</div>
          </div>
            </div>

          <!-- Contact Section -->
          <div style="margin-bottom: 1rem;">
            <div style="font-size: 0.6875rem; font-weight: 600; color: #9ca3af; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.5rem;">CONTATO</div>

            <!-- Email -->
            <div style="background-color: #f9fafb; border-radius: 0.375rem; padding: 0.5rem 0.625rem; margin-bottom: 0.375rem; border: 1px solid #e5e7eb;">
              <div style="display: flex; align-items: center; gap: 0.5rem;">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #6b7280; flex-shrink: 0;">
                  <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                  <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                </svg>
                <div style="flex: 1; min-width: 0;">
                  <div style="font-size: 0.6875rem; color: #6b7280; margin-bottom: 0.125rem;">Email</div>
                  <div style="font-size: 0.8125rem; color: #111827; font-weight: 500;">{{ selectedUser.email || '-' }}</div>
          </div>
        </div>
      </div>

            <!-- Telefone -->
            <div style="background-color: #f9fafb; border-radius: 0.375rem; padding: 0.5rem 0.625rem; margin-bottom: 0.375rem; border: 1px solid #e5e7eb;">
              <div style="display: flex; align-items: center; gap: 0.5rem;">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #6b7280; flex-shrink: 0;">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
                <div style="flex: 1; min-width: 0;">
                  <div style="font-size: 0.6875rem; color: #6b7280; margin-bottom: 0.125rem;">Telefone</div>
                  <div style="font-size: 0.8125rem; color: #111827; font-weight: 500;">{{ selectedUser.phone || '-' }}</div>
    </div>
              </div>
            </div>

            <!-- Ramal -->
            <div style="background-color: #f9fafb; border-radius: 0.375rem; padding: 0.5rem 0.625rem; border: 1px solid #e5e7eb;">
              <div style="display: flex; align-items: center; gap: 0.5rem;">
                <div style="width: 14px; height: 14px; display: flex; align-items: center; justify-content: center; color: #6b7280; flex-shrink: 0; font-size: 0.875rem; font-weight: 600;">#</div>
                <div style="flex: 1; min-width: 0;">
                  <div style="font-size: 0.6875rem; color: #6b7280; margin-bottom: 0.125rem;">Ramal</div>
                  <div style="font-size: 0.8125rem; color: #111827; font-weight: 500;">{{ getUserExtension(selectedUser) || '-' }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Status (e Plano só quando modelo é ilimitado e showBillingColumns) -->
          <div :style="{ display: 'grid', gridTemplateColumns: (isUnlimited && showBillingColumns) ? '1fr 1fr' : '1fr', gap: '0.5rem', marginBottom: '1rem' }">
            <!-- Status -->
            <div style="background-color: #f9fafb; border-radius: 0.375rem; padding: 0.5rem 0.625rem; border: 1px solid #e5e7eb;">
              <div style="font-size: 0.6875rem; color: #6b7280; margin-bottom: 0.375rem;">Status</div>
              <div>
                <span
                  v-if="getStatusLabel(selectedUser) === 'Ativo'"
                  style="display: inline-flex; align-items: center; padding: 0.2rem 0.625rem; border-radius: 9999px; font-size: 0.8125rem; font-weight: 600; background-color: #dcfce7; color: #166534; border: 1px solid #86efac;">
                  {{ getStatusLabel(selectedUser) }}
                </span>
                <span
                  v-else-if="getStatusLabel(selectedUser) === 'Aguardando pagamento'"
                  style="display: inline-flex; align-items: center; padding: 0.2rem 0.625rem; border-radius: 9999px; font-size: 0.8125rem; font-weight: 600; background-color: #fef3c7; color: #92400e; border: 1px solid #fcd34d;">
                  {{ getStatusLabel(selectedUser) }}
                </span>
                <span
                  v-else
                  style="display: inline-flex; align-items: center; padding: 0.2rem 0.625rem; border-radius: 9999px; font-size: 0.8125rem; font-weight: 600; background-color: #e5e7eb; color: #4b5563; border: 1px solid #d1d5db;">
                  {{ getStatusLabel(selectedUser) }}
                </span>
              </div>
            </div>

            <!-- Plano (apenas quando modelo é ilimitado e showBillingColumns) -->
            <div v-if="isUnlimited && showBillingColumns" style="background-color: #f9fafb; border-radius: 0.375rem; padding: 0.5rem 0.625rem; border: 1px solid #e5e7eb;">
              <div style="font-size: 0.6875rem; color: #6b7280; margin-bottom: 0.375rem;">Plano</div>
              <div>
                <plan-badge
                  v-if="userPlanData[selectedUser.id]"
                  :plan="userPlanData[selectedUser.id].plan" />
                <span v-else style="color: #9ca3af; font-size: 0.875rem;">Não definido</span>
              </div>
            </div>
          </div>

          <!-- Action Buttons (apenas Fechar; Editar fica no menu da linha) -->
          <div style="display: flex; justify-content: flex-end; gap: 0.5rem; padding-top: 0.75rem;">
            <button
              @click="closeDetailsModal"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 0.375rem; white-space: nowrap; border-radius: 0.375rem; font-size: 0.8125rem; font-weight: 500; height: 2.25rem; padding-left: 1.25rem; padding-right: 1.25rem; background-color: #ffffff; color: #374151; border: 1px solid #e5e7eb; cursor: pointer; transition: all 0.2s;">
              Fechar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Editar Usuário -->
    <div
      v-if="showEditModal && userToEdit"
      class="modal-overlay"
      @click.self="closeEditModal"
      @click="handleOverlayClick"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5); z-index: 1060; display: flex; align-items: center; justify-content: center;">
      <div
      role="dialog"
        class="edit-user-modal"
        @click.stop
        style="pointer-events: auto; max-width: 32rem; width: 90%; background: white; border-radius: 0.75rem; padding: 0; position: relative; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04); z-index: 1061; overflow: visible;">

        <!-- Header -->
        <div style="display: flex; align-items: flex-start; justify-content: space-between; padding: 1.5rem 1.5rem 1rem 1.5rem;">
          <div style="flex: 1;">
            <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #374151;">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
              </svg>
              <h3 style="font-size: 1.125rem; font-weight: 700; margin: 0; color: #111827;">Editar Usuário</h3>
            </div>
            <div style="font-size: 0.875rem; color: #6b7280; margin-top: 0.25rem;">
              {{ userToEdit.name || 'Sem nome' }} ({{ userToEdit.email }})
            </div>
          </div>
          <button
            type="button"
            style="background: transparent; border: none; cursor: pointer; padding: 0.25rem; display: flex; align-items: center; justify-content: center; color: #6b7280; margin-left: 1rem;"
            @click="closeEditModal">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 6 6 18"></path>
              <path d="m6 6 12 12"></path>
            </svg>
          </button>
        </div>

        <!-- Content -->
        <div style="padding: 1.5rem;">
          <p v-if="editIsWizard" style="font-size: 0.75rem; color: #6b7280; margin: 0 0 1rem 0;">
            Etapa {{ editStep }} de 2 · {{ editStep === 1 ? 'Plano e proporcional' : 'Pagamento' }}
          </p>
          <template v-if="!editIsWizard || editStep === 1">
          <div style="margin-bottom: 1.25rem;">
            <label style="display: block; font-size: 0.875rem; font-weight: 500; color: #374151; margin-bottom: 0.5rem;">Status</label>
            <div
              v-if="editStatusLocked"
              style="width: 100%; display: flex; align-items: center; padding: 0.625rem 0.875rem; background-color: #f9fafb; border: 1px solid #e5e7eb; border-radius: 0.5rem; font-size: 0.875rem; color: #6b7280; cursor: not-allowed;">
              <span style="display: inline-flex; align-items: center; padding: 0.25rem 0.625rem; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background-color: #fef3c7; color: #92400e;">
                {{ editForm.status }}
              </span>
              <span style="margin-left: 0.5rem; font-size: 0.75rem; color: #9ca3af;"></span>
            </div>
            <div v-else class="dropdown" :style="{ position: 'relative', width: '100%', zIndex: showStatusDropdown ? 10001 : 1 }">
            <button
              type="button"
                class="edit-dropdown-button"
                @click.stop="toggleStatusDropdown"
                style="width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 0.625rem 0.875rem; background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem; color: #111827; cursor: pointer; transition: all 0.2s; position: relative;">
                <span style="display: flex; align-items: center; gap: 0.5rem;">
                  <span
                    v-if="editForm.status === 'Ativo'"
                    style="display: inline-flex; align-items: center; padding: 0.25rem 0.625rem; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background-color: #dcfce7; color: #166534;">
                    {{ editForm.status }}
                  </span>
                  <span
                    v-else
                    style="display: inline-flex; align-items: center; padding: 0.25rem 0.625rem; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background-color: #e5e7eb; color: #4b5563;">
                    {{ editForm.status }}
                  </span>
                </span>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #6b7280;">
                  <path d="m6 9 6 6 6-6"></path>
                </svg>
            </button>
              <div
                v-if="showStatusDropdown"
                class="dropdown-menu"
                @click.stop
                style="position: absolute; top: 100%; left: 0; right: 0; margin-top: 0.25rem; background: white; border: 1px solid #e5e7eb; border-radius: 0.5rem; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); z-index: 10001; max-height: 200px; overflow-y: auto; min-width: 100%;">
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="selectStatus('Ativo')"
                  style="display: block; padding: 0.625rem 0.875rem; color: #374151; text-decoration: none; font-size: 0.875rem; transition: background-color 0.2s;">
                  <span style="display: inline-flex; align-items: center; padding: 0.25rem 0.625rem; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background-color: #dcfce7; color: #166534;">Ativo</span>
                </a>
                <a
                  v-if="editAwaitingCanTakeVacantSeat"
                  class="dropdown-item"
                  href="#"
                  @click.prevent="selectStatus('Aguardando pagamento')"
                  style="display: block; padding: 0.625rem 0.875rem; color: #374151; text-decoration: none; font-size: 0.875rem; transition: background-color 0.2s;">
                  <span style="display: inline-flex; align-items: center; padding: 0.25rem 0.625rem; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background-color: #fef3c7; color: #92400e;">Aguardando pagamento</span>
                </a>
                <a
                  v-else
                  class="dropdown-item"
                  href="#"
                  @click.prevent="selectStatus('Desativado')"
                  style="display: block; padding: 0.625rem 0.875rem; color: #374151; text-decoration: none; font-size: 0.875rem; transition: background-color 0.2s;">
                  <span style="display: inline-flex; align-items: center; padding: 0.25rem 0.625rem; border-radius: 9999px; font-size: 0.75rem; font-weight: 600; background-color: #e5e7eb; color: #4b5563;">Desativado</span>
                </a>
          </div>
          </div>
          </div>
          <p v-if="editReleasesSeat" style="font-size: 0.75rem; color: #b45309; margin: -0.5rem 0 1.25rem 0;">
            <template v-if="editCurrentPlanIsFree">O usuário perderá o acesso. A licença gratuita dele sairá da assinatura.</template>
            <template v-else>O usuário perderá o acesso. A licença continuará contratada e ficará livre para outro usuário.</template>
          </p>

          <!-- Tipo de Acesso e Plano Fields (lado a lado quando ilimitado) -->
          <div :style="{ display: 'grid', gridTemplateColumns: isUnlimited ? '1fr 1fr' : '1fr', gap: '1rem', marginBottom: '1.5rem' }">
            <!-- Tipo de Acesso Field -->
            <div>
              <label style="display: block; font-size: 0.875rem; font-weight: 500; color: #374151; margin-bottom: 0.5rem;">Tipo de Acesso</label>
              <div class="dropdown" :style="{ position: 'relative', width: '100%', zIndex: showAccessTypeDropdown ? 10001 : 1 }">
              <button
                type="button"
                  class="edit-dropdown-button"
                  @click.stop="toggleAccessTypeDropdown"
                  style="width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 0.625rem 0.875rem; background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem; color: #111827; cursor: pointer; transition: all 0.2s; position: relative;">
                  <span style="display: flex; align-items: center; gap: 0.5rem;">
                    <svg v-if="editForm.accessType === 'Administrador'" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M10 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2m10 1a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m3 3h1m-4 3a3 3 0 0 1-3-3m3 3v1m-3-4a3 3 0 0 1 3-3m-3 3h-1m4-3v-1m-2.121 1.879-.707-.707m5.656 5.656-.707-.707m-4.242 0-.707.707m5.656-5.656-.707.707M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                    </svg>
                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                    </svg>
                    <span>{{ editForm.accessType }}</span>
                  </span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #6b7280;">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </button>
                <div
                  v-if="showAccessTypeDropdown"
                  class="dropdown-menu"
                  @click.stop
                  style="position: absolute; top: 100%; left: 0; right: 0; margin-top: 0.25rem; background: white; border: 1px solid #e5e7eb; border-radius: 0.5rem; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); z-index: 10001; min-width: 100%;">
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="selectAccessType('Administrador')"
                    style="display: flex; align-items: center; gap: 0.5rem; padding: 0.625rem 0.875rem; color: #374151; text-decoration: none; font-size: 0.875rem; transition: background-color 0.2s;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M10 19H5a1 1 0 0 1-1-1v-1a3 3 0 0 1 3-3h2m10 1a3 3 0 0 1-3 3m3-3a3 3 0 0 0-3-3m3 3h1m-4 3a3 3 0 0 1-3-3m3 3v1m-3-4a3 3 0 0 1 3-3m-3 3h-1m4-3v-1m-2.121 1.879-.707-.707m5.656 5.656-.707-.707m-4.242 0-.707.707m5.656-5.656-.707.707M12 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                    </svg>
                    <span>Administrador</span>
                  </a>
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="selectAccessType('Usuário')"
                    style="display: flex; align-items: center; gap: 0.5rem; padding: 0.625rem 0.875rem; color: #374151; text-decoration: none; font-size: 0.875rem; transition: background-color 0.2s;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M7 17v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3Zm8-9a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                    </svg>
                    <span>Usuário</span>
                  </a>
                </div>
              </div>
            </div>

            <!-- Plano Field (apenas quando modelo é ilimitado) -->
            <div v-if="isUnlimited">
              <label style="display: block; font-size: 0.875rem; font-weight: 500; color: #374151; margin-bottom: 0.5rem;">Plano</label>
              <div class="dropdown" :style="{ position: 'relative', width: '100%', zIndex: showPlanDropdown ? 10001 : 1 }">
              <button
                type="button"
                  class="edit-dropdown-button"
                  :disabled="!editPlanDropdownEnabled"
                  @click.stop="togglePlanDropdown"
                  :style="!editPlanDropdownEnabled ? { cursor: 'not-allowed', opacity: 0.55, backgroundColor: '#f9fafb' } : {}"
                  style="width: 100%; display: flex; align-items: center; justify-content: space-between; padding: 0.625rem 0.875rem; background-color: #ffffff; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem; color: #111827; cursor: pointer; transition: all 0.2s; position: relative;">
                  <span>
                    <plan-badge
                      v-if="editSelectedPlanDetails"
                      :plan="editSelectedPlanDetails.name"
                      :code="editForm.plan" />
                    <span v-else style="color: #6b7280;">Selecione um plano</span>
                  </span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #6b7280;">
                    <path d="m6 9 6 6 6-6"></path>
                  </svg>
                </button>
              <p v-if="editForm.status !== 'Ativo'" style="font-size: 0.75rem; color: #9ca3af; margin: 0.375rem 0 0 0;">O plano é definido ao ativar o usuário.</p>
              <p v-else-if="editUserAtMaxPlan" style="font-size: 0.75rem; color: #9ca3af; margin: 0.375rem 0 0 0;">Este usuário já está no plano máximo.</p>
              <p v-else-if="editIsDowngrade" style="font-size: 0.75rem; color: #b45309; margin: 0.375rem 0 0 0;">A redução de plano (downgrade) é feita pelo time comercial.</p>
                <div
                  v-if="showPlanDropdown"
                  class="dropdown-menu"
                  @click.stop
                  style="position: absolute; top: 100%; left: 0; right: 0; margin-top: 0.25rem; background: white; border: 1px solid #e5e7eb; border-radius: 0.5rem; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); z-index: 10001; min-width: 100%;">
                  <a
                    v-for="plan in editSelectablePlans"
                    :key="plan.code"
                    class="dropdown-item"
                    href="#"
                    @click.prevent="selectPlan(plan.code)"
                    style="display: flex; align-items: center; justify-content: space-between; gap: 0.5rem; padding: 0.625rem 0.875rem; color: #374151; text-decoration: none; font-size: 0.875rem; transition: background-color 0.2s;">
                    <plan-badge :plan="plan.name" :code="plan.code" />
                    <span v-if="vacantSeatCount(plan.code) > 0" style="font-size: 0.75rem; font-weight: 600; color: #166534; background-color: #dcfce7; border-radius: 9999px; padding: 0.125rem 0.5rem;">
                      {{ vacantSeatCount(plan.code) }} {{ vacantSeatCount(plan.code) === 1 ? 'livre' : 'livres' }}
                    </span>
                  </a>
            </div>
          </div>
        </div>
      </div>

          <!-- Pró-rata da ativação (passo 1 do wizard) -->
          <pro-rata-summary
            v-if="editIsActivating && editForm.plan && !editActivatesVacantSeat && !editActivatesFreePlan"
            :plan-details="editSelectedPlanDetails"
            :badge-style="editPlanBadgeStyle"
            :preview="editProrataPreview"
            :loading="editProrataLoading"
            :error="editProrataError"
            style="margin-top: 1.25rem;" />
          <div
            v-if="editActivatesVacantSeat"
            :style="{ backgroundColor: editPlanBadgeStyle.backgroundColor, border: '1px solid ' + editPlanBadgeStyle.borderColor }"
            style="border-radius: 0.5rem; padding: 0.875rem 1rem; margin-top: 1.25rem; font-size: 0.8125rem; color: #374151;">
            Vai ocupar uma licença livre do {{ editSelectedPlanDetails.name }}, sem cobrança.
            <span v-if="editAwaitingCanTakeVacantSeat"> O convite pendente dele será cancelado.</span>
            <p v-if="editVacantSeatExpiry" style="font-size: 0.75rem; color: #b45309; margin: 0.5rem 0 0 0;">
              A licença livre deste plano expira em {{ formatSeatShortDay(editVacantSeatExpiry) }}: o usuário poderá usá-la até {{ formatSeatShortLastUsableDay(editVacantSeatExpiry) }} e será desativado nessa data.
            </p>
            <div v-if="editSelectedPlanDetails.benefits.length > 0" style="font-size: 0.75rem; color: #4b5563; margin-top: 0.5rem;">{{ editSelectedPlanDetails.benefits.join(' · ') }}</div>
          </div>
          <div
            v-if="editActivatesFreePlan"
            :style="{ backgroundColor: editPlanBadgeStyle.backgroundColor, border: '1px solid ' + editPlanBadgeStyle.borderColor }"
            style="border-radius: 0.5rem; padding: 0.875rem 1rem; margin-top: 1.25rem; font-size: 0.8125rem; color: #374151;">
            Plano gratuito: o usuário é ativado sem cobrança.
            <div v-if="editSelectedPlanDetails.benefits.length > 0" style="font-size: 0.75rem; color: #4b5563; margin-top: 0.5rem;">{{ editSelectedPlanDetails.benefits.join(' · ') }}</div>
          </div>

          <!-- Cobrança em aberto que a confirmação vai cancelar e substituir -->
          <div v-if="editPendingInvoice" class="plan-change-pending-disclaimer">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="plan-change-pending-icon" aria-hidden="true">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
              <line x1="12" x2="12" y1="9" y2="13"></line>
              <line x1="12" x2="12.01" y1="17" y2="17"></line>
            </svg>
            <p class="plan-change-pending-text">
              Identificamos uma
              <a
                v-if="editPendingInvoice.externalUrl"
                :href="editPendingInvoice.externalUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="plan-change-pending-link">cobrança de {{ formatUserCurrency(editPendingInvoice.value) }} aguardando pagamento
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="plan-change-pending-link-icon">
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                  <polyline points="15 3 21 3 21 9"></polyline>
                  <line x1="10" y1="14" x2="21" y2="3"></line>
                </svg></a><span v-else>cobrança de {{ formatUserCurrency(editPendingInvoice.value) }} aguardando pagamento</span>.
              Ao continuar, ela será cancelada e uma nova cobrança será gerada com o valor
              <template v-if="editIsUpgrade">deste upgrade</template><template v-else>do plano escolhido</template>.
            </p>
          </div>

          <!-- Resumo do upgrade de um usuário já ativo (diferença proporcional) -->
          <div v-if="editChangePlanLoading" style="margin-top: 1.25rem; font-size: 0.8125rem; color: #6b7280;">Calculando a diferença proporcional...</div>
          <div v-else-if="editIsChangingPlan && editChangePlanError" style="margin-top: 1.25rem; font-size: 0.8125rem; color: #b45309;">{{ editChangePlanError }}</div>
          <div
            v-else-if="editChangePlanUsesVacantSeat"
            :style="{ backgroundColor: editPlanBadgeStyle.backgroundColor, border: '1px solid ' + editPlanBadgeStyle.borderColor }"
            style="border-radius: 0.5rem; padding: 0.875rem 1rem; margin-top: 1.25rem; font-size: 0.8125rem; color: #374151;">
            Existe licença livre no plano {{ editSelectedPlanDetails.name }}: a troca é imediata e sem cobrança.
            {{ editCurrentPlanIsFree ? 'A licença gratuita atual sairá da assinatura.' : 'A licença atual ficará livre para outro usuário.' }}
            <p v-if="editVacantSeatExpiry" style="font-size: 0.75rem; color: #b45309; margin: 0.5rem 0 0 0;">
              A licença livre deste plano expira em {{ formatSeatShortDay(editVacantSeatExpiry) }}: o usuário poderá usá-la até {{ formatSeatShortLastUsableDay(editVacantSeatExpiry) }} e será desativado nessa data.
            </p>
            <div v-if="editSelectedPlanDetails.benefits.length > 0" style="font-size: 0.75rem; color: #4b5563; margin-top: 0.5rem;">{{ editSelectedPlanDetails.benefits.join(' · ') }}</div>
          </div>
          <div
            v-else-if="editIsUpgrade"
            :style="{ backgroundColor: editPlanBadgeStyle.backgroundColor, border: '1px solid ' + editPlanBadgeStyle.borderColor }"
            style="border-radius: 0.5rem; padding: 0.875rem 1rem; margin-top: 1.25rem;">
            <div style="font-size: 0.875rem; font-weight: 600; color: #374151; margin-bottom: 0.25rem;">Upgrade de plano</div>
            <div v-if="editSelectedPlanDetails && editSelectedPlanDetails.benefits.length > 0" style="font-size: 0.75rem; color: #4b5563; margin-bottom: 0.5rem;">{{ editSelectedPlanDetails.benefits.join(' · ') }}</div>
            <div style="display: flex; align-items: baseline; justify-content: space-between; gap: 1rem;">
              <span style="font-size: 0.8125rem; color: #6b7280;">Diferença proporcional (até o fim do ciclo)</span>
              <span style="font-size: 0.8125rem; color: #374151; white-space: nowrap;">{{ formatUserCurrency(editChangePlanPreview.proratedValue) }}</span>
            </div>
            <!-- Mensalidade adiantada: a cobrança do próximo ciclo já foi quitada e saiu
                 com o plano antigo, então a diferença daquele mês vem junto aqui. Sem esta
                 linha o total não bate com a parcela listada acima (TEL-2297). -->
            <div v-if="editChangePlanShowNextCycleFee" style="display: flex; align-items: baseline; justify-content: space-between; gap: 1rem; margin-top: 0.25rem;">
              <span style="font-size: 0.8125rem; color: #6b7280;">Mensalidade do próximo ciclo, já faturado</span>
              <span style="font-size: 0.8125rem; color: #374151; white-space: nowrap;">{{ formatUserCurrency(editChangePlanPreview.nextCycleFee) }}</span>
            </div>
            <div :style="{ borderTop: '1px solid ' + editPlanBadgeStyle.borderColor }" style="display: flex; align-items: baseline; justify-content: space-between; gap: 1rem; margin-top: 0.75rem; padding-top: 0.75rem;">
              <span style="font-size: 0.9375rem; font-weight: 700; color: #111827;">Total a cobrar agora</span>
              <span :style="{ fontSize: '1.125rem', fontWeight: 700, color: editPlanBadgeStyle.color, whiteSpace: 'nowrap' }">{{ formatUserCurrency(editChangePlanTotal) }}</span>
            </div>
          </div>
          </template>

          <!-- PASSO 2: meio de pagamento + contato para cobrança -->
          <div v-if="editIsWizard" v-show="editStep === 2">
            <payment-method-selector v-model="editSelectedPaymentMethod" style="margin-bottom: 1.5rem;" />
            <billing-contact-fields
              ref="editContactFields"
              style="margin-bottom: 1.25rem;"
              @valid="editContactValid = $event" />
          </div>

          <!-- Action Buttons -->
          <div style="display: flex; justify-content: flex-end; gap: 0.75rem; padding-top: 1rem;">
            <!-- Secundário: Voltar (passo 2) ou Cancelar -->
            <button
              v-if="editIsWizard && editStep === 2"
              type="button"
              @click="editStep = 1"
              :disabled="isSaving"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; white-space: nowrap; border-radius: 0.375rem; font-size: 0.875rem; font-weight: 500; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #f9fafb; color: #374151; border: 1px solid #e5e7eb; cursor: pointer; transition: all 0.2s;">
              Voltar
            </button>
            <button
              v-else
              @click="closeEditModal"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; white-space: nowrap; border-radius: 0.375rem; font-size: 0.875rem; font-weight: 500; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #f9fafb; color: #374151; border: 1px solid #e5e7eb; cursor: pointer; transition: all 0.2s;">
              Cancelar
            </button>

            <!-- Primário: Próximo (passo 1) / Confirmar (passo 2) / Salvar (sem wizard) -->
            <button
              v-if="editIsWizard && editStep === 1"
              type="button"
              @click="goToEditStep2"
              :disabled="editStep1Blocked"
              :style="{ opacity: editStep1Blocked ? 0.6 : 1, cursor: editStep1Blocked ? 'not-allowed' : 'pointer' }"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; white-space: nowrap; border-radius: 0.375rem; font-size: 0.875rem; font-weight: 500; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #2563eb; color: #ffffff; border: none; transition: all 0.2s;">
              Próximo
            </button>
            <button
              v-else
              class="btn-salvar-alteracoes"
              @click="saveAndShowInviteSent"
              :disabled="isSaving || (editIsWizard && !editContactValid) || editPlanChangeBlocked"
              :style="{ opacity: (isSaving || (editIsWizard && !editContactValid) || editPlanChangeBlocked) ? 0.6 : 1, cursor: (isSaving || (editIsWizard && !editContactValid) || editPlanChangeBlocked) ? 'not-allowed' : 'pointer' }"
              style="display: inline-flex; align-items: center; justify-content: center; gap: 0.5rem; white-space: nowrap; border-radius: 0.375rem; font-size: 0.875rem; font-weight: 500; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #2563eb; color: #ffffff; border: none; transition: all 0.2s;">
              <span v-if="isSaving">{{ editIsWizard ? 'Gerando cobrança...' : 'Salvando...' }}</span>
              <span v-else>{{ editIsWizard ? 'Confirmar e gerar cobrança' : 'Salvar Alterações' }}</span>
            </button>
    </div>
        </div>
      </div>
    </div>

    <!-- Card Solicitação Enviada! (após Salvar Alterações no editar usuário) -->
    <div
      v-if="showInviteSentCard"
      class="modal-overlay"
      @click.self="closeInviteSentCard"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5); z-index: 1070; display: flex; align-items: center; justify-content: center;">
      <div
        role="dialog"
        class="invite-sent-card"
        @click.stop
        :style="{
          pointerEvents: 'auto',
          maxWidth: (inviteSentCardAccessTypeOnly || !isUnlimited) ? '20rem' : '28rem',
          width: '92%',
          background: 'white',
          borderRadius: '0.75rem',
          padding: 0,
          position: 'relative',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
          zIndex: 1071,
          overflow: 'hidden'
        }">
        <!-- Layout centralizado para feedback simples (Alteração realizada com sucesso) -->
        <template v-if="inviteSentCardAccessTypeOnly || !isUnlimited">
          <button type="button" style="position: absolute; top: 0.75rem; right: 0.75rem; background: transparent; border: none; cursor: pointer; padding: 0.25rem; color: #6b7280; z-index: 1;" @click="closeInviteSentCard">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
          </button>
          <div style="padding: 2rem 1.5rem 1.5rem; text-align: center;">
            <div style="display: flex; justify-content: center; margin-bottom: 1rem;">
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" style="flex-shrink: 0;">
                <circle cx="12" cy="12" r="5.5" stroke="#16a34a" stroke-width="1.25" stroke-dasharray="29 5" stroke-dashoffset="0"/>
                <path d="M10 11l2 2 5-3.5" stroke="#16a34a" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h3 style="font-size: 1.125rem; font-weight: 700; margin: 0 0 1.5rem; color: #16a34a;">Alteração realizada com sucesso</h3>
            <button
              type="button"
              @click="closeInviteSentCard"
              style="display: inline-flex; align-items: center; justify-content: center; border-radius: 0.5rem; font-size: 0.875rem; font-weight: 600; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #2563eb; color: #ffffff; border: none; cursor: pointer;">
              Entendido
            </button>
          </div>
        </template>
        <!-- Layout com conteúdo extra (Alteração realizada) -->
        <template v-else>
          <div style="padding: 1.5rem 1.5rem 1rem 1.5rem; display: flex; justify-content: space-between; align-items: flex-start;">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" style="flex-shrink: 0;">
                <circle cx="12" cy="12" r="5.5" stroke="#16a34a" stroke-width="1.25" stroke-dasharray="29 5" stroke-dashoffset="0"/>
                <path d="M10 11l2 2 5-3.5" stroke="#16a34a" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <h3 style="font-size: 1.125rem; font-weight: 700; margin: 0; color: #16a34a;">Alteração realizada com sucesso</h3>
            </div>
            <button type="button" style="background: transparent; border: none; cursor: pointer; padding: 0.25rem; color: #6b7280;" @click="closeInviteSentCard">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
            </button>
          </div>
          <div style="padding: 0 1.5rem 1.5rem 1.5rem;">
            <div v-if="inviteSentShowConfirmationLink && !inviteSentCardAccessTypeOnly" style="background: #f9fafb; border-radius: 0.5rem; padding: 0.75rem 1rem; margin-bottom: 1.5rem;">
              <template v-if="activationPaymentLink">
                <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" style="flex-shrink: 0;"><rect width="20" height="14" x="2" y="5" rx="2"></rect><line x1="2" x2="22" y1="10" y2="10"></line></svg>
                  <span style="font-size: 0.875rem; color: #374151;">Cobrança pró-rata gerada<template v-if="activationChargeValue != null"> ({{ formatCurrency(activationChargeValue) }})</template>. O usuário fica "Aguardando pagamento" até a compensação.</span>
                </div>
                <a :href="activationPaymentLink" target="_blank" rel="noopener" style="font-size: 0.875rem; color: #2563eb; word-break: break-all;">Abrir link de pagamento</a>
              </template>
              <span v-else-if="vacantSeatMessage" style="font-size: 0.875rem; color: #374151;">{{ vacantSeatMessage }}</span>
              <div v-else style="display: flex; align-items: center; gap: 0.5rem;">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" style="flex-shrink: 0;"><rect width="20" height="16" x="2" y="4" rx="2"></rect><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path></svg>
                <span style="font-size: 0.875rem; color: #374151;">Um link de confirmação foi enviado para {{ inviteSentEmail }}.</span>
              </div>
            </div>

            <div style="display: flex; justify-content: flex-end; gap: 0.5rem;">
              <button
                v-if="deactivatedSeatTransfer"
                type="button"
                @click="transferDeactivatedSeat"
                style="display: inline-flex; align-items: center; justify-content: center; border-radius: 0.5rem; font-size: 0.875rem; font-weight: 600; height: 2.5rem; padding-left: 1.25rem; padding-right: 1.25rem; background-color: #ffffff; color: #2563eb; border: 1px solid #2563eb; cursor: pointer;">
                Transferir a licença para…
              </button>
              <button
                type="button"
                @click="closeInviteSentCard"
                style="display: inline-flex; align-items: center; justify-content: center; border-radius: 0.5rem; font-size: 0.875rem; font-weight: 600; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #2563eb; color: #ffffff; border: none; cursor: pointer;">
                Entendido
              </button>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div
      v-if="resendInviteError"
      class="modal-overlay"
      @click.self="resendInviteError = ''"
      style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0, 0, 0, 0.5); z-index: 1070; display: flex; align-items: center; justify-content: center;">
      <div
        role="dialog"
        @click.stop
        style="max-width: 20rem; width: 92%; background: white; border-radius: 0.75rem; position: relative; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); overflow: hidden;">
        <div style="padding: 2rem 1.5rem 1.5rem; text-align: center;">
          <h3 style="font-size: 1.125rem; font-weight: 700; margin: 0 0 1.5rem; color: #991b1b;">{{ resendInviteError }}</h3>
          <button
            type="button"
            @click="resendInviteError = ''"
            style="display: inline-flex; align-items: center; justify-content: center; border-radius: 0.5rem; font-size: 0.875rem; font-weight: 600; height: 2.5rem; padding-left: 1.5rem; padding-right: 1.5rem; background-color: #2563eb; color: #ffffff; border: none; cursor: pointer;">
            Entendido
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { getSubscriptionContext, getPendingSeatPurchase, occupySeat } from '@/services/subscription'
import { isVacantSeat, isLeavingSeat, VACANT_SEAT_PATH, vacantSeatExpiryByPlanCode, formatSeatShortDay, formatSeatShortLastUsableDay } from '@/utils/seats'
import { loadAndMapOffers } from '@/services/pricing-offers'
import { formatCurrency } from '@/utils/currency'
import { friendlyPlainText } from '@/utils/error-message'
import { getInviteEligibility, resolveInviteEligibilityMaxUsers, isOrganizationUserLimitExempt, isAccountRestricted } from '@/services/invite-eligibility'
import moment from 'moment-timezone'
import SummaryCard from './SummaryCard.vue'
import DistributionButton from './DistributionButton.vue'
import PlanBadge from './PlanBadge.vue'
import AddUserModal from './AddUserModal.vue'
import UserLimitReachedModal from './UserLimitReachedModal.vue'
import SessionOutdatedModal from './SessionOutdatedModal.vue'
import AccountRestrictedModal from './AccountRestrictedModal.vue'
import ProRataSummary from './invite/ProRataSummary.vue'
import PaymentMethodSelector from './invite/PaymentMethodSelector.vue'
import BillingContactFields from './invite/BillingContactFields.vue'
import TransferSeatModal from './seats/TransferSeatModal.vue'
import PurchaseSeatsModal from './seats/PurchaseSeatsModal.vue'
import SeatsTable from './seats/SeatsTable.vue'
import AssignSeatModal from './seats/AssignSeatModal.vue'
import { getPlanBadgeStyle, getPlanDisplayName, PLAN_CODE_MANAGER } from '@/utils/plan-badge'
import { planBenefitLabels } from '../Subscription/pricing-comparison'
import { billingTypeForPaymentMethod } from '@/utils/billing-type'

const USER_STATUS = Object.freeze({
  ACTIVE: Object.freeze({ api: 'ACTIVE', key: 'active', label: 'Ativo' }),
  INACTIVE: Object.freeze({ api: 'INACTIVE', key: 'inactive', label: 'Desativado' }),
  AWAITING_PAYMENT: Object.freeze({ api: 'AWAITING_PAYMENT', key: 'awaiting_payment', label: 'Aguardando pagamento' })
})

const API_TO_KEY = Object.freeze(Object.fromEntries(Object.values(USER_STATUS).map(s => [s.api, s.key])))
const KEY_TO_LABEL = Object.fromEntries(Object.values(USER_STATUS).map(s => [s.key, s.label]))
const LABEL_TO_API = Object.fromEntries(Object.values(USER_STATUS).map(s => [s.label, s.api]))

// PAGINAÇÃO DA LISTA (TEL-2366) — busca a conta inteira em páginas, não numa requisição só.
//
// Esta tela filtra, ordena e soma no CLIENTE (filteredUsers/sortedUsers e os totais do
// rodapé), então ela precisa da lista completa em mãos: paginar no servidor sem mover os
// filtros junto faria a "página 1 filtrada" deixar de ser o começo do conjunto filtrado.
// Enquanto plano e valor vierem do /subscriptions (billing) e não do /users, filtrar por
// plano no servidor não é possível — por isso a lista inteira, e não paginação server-side.
//
// Antes era uma requisição única de limit=500. A conta com 596 usuários exibia 500 e o
// rodapé dizia "de 500 usuários": os 96 restantes não apareciam na tabela nem na busca, e
// nada na tela indicava que faltava alguém. O corte era ruim; o silêncio era pior.
const USERS_PAGE_SIZE = 200

// Teto absoluto de segurança (20 × 200 = 4.000 usuários). O /users não impõe limite de
// paginação no pbxapi — o paginationGuard só é montado em /calls e /cdrs —, então quem
// precisa se proteger de uma conta gigante é esta tela. Ao bater o teto ela PARA e AVISA
// (usersTruncated), em vez de cortar calado como antes.
//
// Custo: o /users tem limiter próprio de 100 req/min por usuário, então mesmo o pior caso
// (20 requisições) usa um quinto da janela.
const USERS_MAX_PAGES = 20

export default {
  name: 'UsersList',
  components: {
    SummaryCard,
    DistributionButton,
    PlanBadge,
    AddUserModal,
    UserLimitReachedModal,
    SessionOutdatedModal,
    AccountRestrictedModal,
    ProRataSummary,
    PaymentMethodSelector,
    BillingContactFields,
    SeatsTable,
    AssignSeatModal,
    TransferSeatModal,
    PurchaseSeatsModal
  },
  data () {
    return {
      error: null,
      isLoading: false,
      users: [],
      // true quando a busca parou no teto de USERS_MAX_PAGES e a conta pode ter mais
      // usuários do que a tela carregou. Alimenta o aviso do rodapé.
      usersTruncated: false,
      showValueColumn: false,
      // CONSUMO DO CICLO — desligado enquanto não existe agregação por ramal no backend
      // (ver comentário em loadUsers). Controla o card "Consumo do Ciclo Atual", a coluna
      // "Consumo" da tabela e o total do rodapé, juntos — os três precisam acompanhar um
      // ao outro, senão o cabeçalho e as células saem desalinhados.
      // Para religar: true. A UI já trata current === null exibindo "—"/"-".
      showConsumptionColumn: false,
      subscriptionNetValue: null,
      userPlanData: {},
      userConsumption: {},
      seats: [],
      activeTab: 'users',
      seatToAssign: null,
      seatsLoaded: false,
      seatTransferFrom: null,
      seatTransferSenderDeactivated: false,
      // Licença paga de quem acabou de ser desativado: o card de sucesso oferece
      // transferi-la sem passar pelo menu do usuário.
      deactivatedSeatTransfer: null,
      showPurchaseSeatsModal: false,
      // Compra de licenças ainda não paga: aparece na aba Licenças como um pacote,
      // com o link da cobrança, mas não é licença — ela só nasce no pagamento.
      pendingSeatPurchase: null,
      vacantSeatMessage: '',
      billingDay: null,
      filters: {
        search: '',
        // Os planos selecionados vêm como lista de CÓDIGOS, montada do pricingList.
        // Antes eram três chaves fixas com o nome de exibição, e qualquer plano fora
        // delas (os com IA4COM) sumia do filtro e da distribuição.
        plans: {
          all: true,
          codes: []
        },
        status: {
          all: true,
          active: false,
          awaitingPayment: false,
          inactive: false
        }
      },
      currentPage: 1,
      perPage: 10,
      perPageOptions: [10, 20, 30, 50],
      pricingList: [],
      showAddUserModal: false,
      showUserLimitReachedModal: false,
      showSessionOutdatedModal: false,
      showAccountRestrictedModal: false,
      inviteEligibilityBlockMessage: '',
      inviteEligibilityMaxUsers: null,
      showDetailsModal: false,
      selectedUser: null,
      showEditModal: false,
      userToEdit: null,
      editForm: {
        status: '',
        accessType: '',
        plan: ''
      },
      initialEditForm: {
        status: '',
        accessType: '',
        plan: ''
      },
      showInviteSentCard: false,
      inviteSentCardAccessTypeOnly: false,
      inviteSentDisplayName: '',
      inviteSentShortName: '',
      inviteSentEmail: '',
      inviteSentShowConfirmationLink: false,
      resendingInviteEmail: '',
      resendInviteError: '',
      activationPaymentLink: '',
      activationChargeValue: null,
      editStep: 1,
      editProrataPreview: null,
      editProrataLoading: false,
      editProrataError: null,
      editChangePlanPreview: null,
      editChangePlanLoading: false,
      editChangePlanError: null,
      editSelectedPaymentMethod: 'credit_card',
      editContactValid: false,
      showStatusDropdown: false,
      showAccessTypeDropdown: false,
      showPlanDropdown: false,
      showStatusFilterDropdown: false,
      showPlanFilterDropdown: false,
      isSaving: false,
      sortField: null,
      sortDirection: 'asc',
      inviteEligibilityCutoffDate: null,
      canInvite: true
    }
  },
  computed: {
    showActiveUserLimitFooter () {
      if (this.isUnlimited) return false
      const organization = this.$store.state.auth.organization || {}
      if (isOrganizationUserLimitExempt(organization)) return false
      const createdAtRaw = organization.created_at || organization.createdAt
      if (this.inviteEligibilityCutoffDate && createdAtRaw) {
        const createdAt = new Date(createdAtRaw)
        const cutoffDate = new Date(this.inviteEligibilityCutoffDate)
        if (!isNaN(createdAt.getTime()) && !isNaN(cutoffDate.getTime())) {
          return createdAt >= cutoffDate
        }
      }
      return !this.canInvite
    },
    nextDueMoment () {
      if (this.billingDay === null) return null
      const nextDue = moment().date(this.billingDay)
      if (moment().date() >= this.billingDay) nextDue.add(1, 'month')
      return nextDue
    },
    cycleRange () {
      if (this.nextDueMoment === null) return null
      return {
        start: this.nextDueMoment.clone().subtract(1, 'month').startOf('day'),
        end: this.nextDueMoment.clone().startOf('day')
      }
    },
    cycleDisplay () {
      if (this.cycleRange === null) return ''
      const start = this.cycleRange.start
      const end = this.cycleRange.end.clone().subtract(1, 'day')
      return `${start.format('DD/MM/YYYY')} a ${end.format('DD/MM/YYYY')}`
    },
    nextDueDate () {
      if (this.nextDueMoment === null) return ''
      return this.nextDueMoment.format('DD/MM/YYYY')
    },
    activeUsersCount () {
      return this.users.filter(u => this.getUserStatus(u) === USER_STATUS.ACTIVE.key).length
    },
    // Quantidade de cards de resumo visíveis, para o grid não abrir coluna vazia.
    summaryCardsCount () {
      let count = 1 // "Usuários Ativos" é sempre exibido
      if (this.subscriptionNetValue !== null) count++
      if (this.showConsumptionColumn) count++
      return count
    },
    // Colspan da linha "nenhum usuário": tem que bater com as colunas realmente renderizadas.
    emptyStateColspan () {
      if (!this.isUnlimited) return 4 // nome, ramal, status, ações
      if (!this.showBillingColumns) return 3 // nome, status, ações
      // nome, status, plano, ações + consumo? + valor?
      return 4 + (this.showConsumptionColumn ? 1 : 0) + (this.showValueColumn ? 1 : 0)
    },
    // Somas de consumo devolvem null quando o dado está indisponível (ver CONSUMO DO CICLO
    // em loadUsers). Somar tratando null como 0 exibiria "0 min" — leitura errada de cobrança.
    totalConsumption () {
      return this.sumConsumption(Object.values(this.userConsumption))
    },
    // Um item por plano ofertado, na ordem do catálogo — alimenta o filtro e a
    // distribuição. Só entram os planos que algum usuário de fato tem, mais os do
    // pricingList, para o filtro não listar plano que ninguém usa.
    planDistribution () {
      const countByPlanCode = {}
      this.pricingList.forEach(plan => {
        countByPlanCode[plan.code] = 0
      })
      this.users.forEach(user => {
        const planCode = this.getUserPlanCode(user)
        if (planCode && countByPlanCode[planCode] !== undefined) {
          countByPlanCode[planCode]++
        }
      })
      return this.pricingList
        .filter(plan => countByPlanCode[plan.code] > 0)
        .map(plan => ({ code: plan.code, name: plan.name, count: countByPlanCode[plan.code] }))
    },
    planFilterLabel () {
      const { all, codes } = this.filters.plans
      if (all || codes.length === 0) return 'Todos os planos'
      if (codes.length === 1) {
        const plan = this.pricingList.find(p => p.code === codes[0])
        return plan ? plan.name : getPlanDisplayName(codes[0])
      }
      return `${codes.length} planos`
    },
    allPlansSelected () {
      return this.filters.plans.all
    },
    statusFilterLabel () {
      const status = this.filters.status
      if (status.all) return 'Todos os status'
      const countAwaiting = this.isUnlimited && this.showBillingColumns && status.awaitingPayment
      const selectedStatusCount = [status.active, countAwaiting, status.inactive].filter(Boolean).length
      if (selectedStatusCount === 0) return 'Todos os status'
      if (selectedStatusCount === 1) {
        if (status.active) return 'Ativo'
        if (countAwaiting) return 'Aguardando pagamento'
        return 'Desativado'
      }
      return `${selectedStatusCount} status`
    },
    filteredUsers () {
      let filtered = this.users

      if (this.filters.search) {
        const search = this.filters.search.toLowerCase()
        filtered = filtered.filter(user => {
          const name = (user.name || '').toLowerCase()
          const email = (user.email || '').toLowerCase()
          return name.includes(search) || email.includes(search)
        })
      }

      if (!this.filters.plans.all) {
        const selectedPlanCodes = this.filters.plans.codes
        if (selectedPlanCodes.length > 0) {
          filtered = filtered.filter(user => {
            const planCode = this.getUserPlanCode(user)
            return planCode && selectedPlanCodes.includes(planCode)
          })
        }
      }

      if (!this.filters.status.all) {
        const statusFilters = []
        if (this.filters.status.active) statusFilters.push(USER_STATUS.ACTIVE.key)
        if (this.isUnlimited && this.showBillingColumns && this.filters.status.awaitingPayment) statusFilters.push(USER_STATUS.AWAITING_PAYMENT.key)
        if (this.filters.status.inactive) statusFilters.push(USER_STATUS.INACTIVE.key)
        if (statusFilters.length > 0) {
          filtered = filtered.filter(user => statusFilters.includes(this.getUserStatus(user)))
        }
      }

      return filtered
    },
    sortedUsers () {
      if (!this.sortField) return this.filteredUsers

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      const sorted = [...this.filteredUsers].sort((a, b) => {
        let aVal, bVal

        switch (this.sortField) {
          case 'name':
            aVal = (a.name || '').toLowerCase()
            bVal = (b.name || '').toLowerCase()
            break
          case 'status':
            aVal = this.getStatusLabel(a)
            bVal = this.getStatusLabel(b)
            break
          case 'extension':
            aVal = (this.getUserExtension(a) || '').toString().toLowerCase()
            bVal = (this.getUserExtension(b) || '').toString().toLowerCase()
            break
          case 'consumption':
            aVal = (this.userConsumption[a.id] && this.userConsumption[a.id].current) || 0
            bVal = (this.userConsumption[b.id] && this.userConsumption[b.id].current) || 0
            break
          case 'plan':
            aVal = (this.userPlanData[a.id] && this.userPlanData[a.id].plan) || ''
            bVal = (this.userPlanData[b.id] && this.userPlanData[b.id].plan) || ''
            break
          case 'value':
            aVal = (this.userPlanData[a.id] && this.userPlanData[a.id].value) || 0
            bVal = (this.userPlanData[b.id] && this.userPlanData[b.id].value) || 0
            break
          default:
            return 0
        }

        if (aVal < bVal) return this.sortDirection === 'asc' ? -1 : 1
        if (aVal > bVal) return this.sortDirection === 'asc' ? 1 : -1
        return 0
      })

      return sorted
    },
    paginatedUsers () {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      return this.sortedUsers.slice(start, end)
    },
    totalConsumptionFiltered () {
      return this.sumConsumption(this.sortedUsers.map(user => this.userConsumption[user.id]))
    },
    totalValueFiltered () {
      return this.sortedUsers.reduce((sum, user) => {
        const planData = this.userPlanData[user.id]
        return sum + (planData && planData.value ? planData.value : 0)
      }, 0)
    },
    totalConsumptionPage () {
      return this.sumConsumption(this.paginatedUsers.map(user => this.userConsumption[user.id]))
    },
    totalValuePage () {
      return this.paginatedUsers.reduce((sum, user) => {
        const planData = this.userPlanData[user.id]
        return sum + (planData && planData.value ? planData.value : 0)
      }, 0)
    },
    allStatusSelected () {
      return this.filters.status.all
    },
    isUnlimited () {
      const organization = this.$store.state.auth.organization
      if (organization === null || organization === undefined) {
        return false
      }
      return organization.isUnlimited === true
    },
    isAdmin () {
      const currentUser = this.$store.state.auth.user
      return !!currentUser && currentUser.role === 'ADMIN'
    },
    seatsDecoupled () {
      return this.isUnlimited && this.$store.state.auth.organization.seatsDecoupled === true
    },
    canManageSeats () {
      return this.seatsDecoupled && this.isAdmin
    },
    vacantSeats () {
      return this.seats.filter(isVacantSeat)
    },
    showLicensesTab () {
      return this.canManageSeats && this.seatsLoaded && this.activeTab === 'licenses'
    },
    // O painel mostra o que é cobrado: licença de plano sem mensalidade (Gerencial)
    // não entra. Plano fora do catálogo continua aparecendo, para nada sumir calado.
    paidSeats () {
      const freePlanCodes = this.pricingList
        .filter(plan => Number(plan.monthlyFee) === 0)
        .map(plan => plan.code)
      return this.seats.filter(seat => !freePlanCodes.includes(seat.planCode))
    },
    vacantSeatPlanCodes () {
      if (!this.seatsDecoupled) return []
      return this.vacantSeats.map(seat => seat.planCode)
    },
    vacantSeatExpiryByPlanCode () {
      if (!this.seatsDecoupled) return {}
      return vacantSeatExpiryByPlanCode(this.seats)
    },
    // Entrar numa licença livre que expira não cancela a expiração: o usuário é
    // desativado quando ela vence.
    editVacantSeatExpiry () {
      if (!this.editActivatesVacantSeat && !this.editChangePlanUsesVacantSeat) return null
      const expiry = this.vacantSeatExpiryByPlanCode[this.editForm.plan]
      return expiry === undefined ? null : expiry
    },
    seatCandidates () {
      return this.users
        .filter(user => this.isSeatCandidate(user))
        .map(user => ({
          email: user.email,
          name: user.name ? user.name : user.email,
          isAwaitingPayment: this.getUserStatus(user) === USER_STATUS.AWAITING_PAYMENT.key
        }))
    },
    editAwaitingCanTakeVacantSeat () {
      return this.canManageSeats &&
        this.initialEditForm.status === USER_STATUS.AWAITING_PAYMENT.label &&
        this.vacantSeats.length > 0
    },
    editStatusLocked () {
      return this.initialEditForm.status === USER_STATUS.AWAITING_PAYMENT.label && !this.editAwaitingCanTakeVacantSeat
    },
    editActivatesVacantSeat () {
      return this.editIsActivating && !!this.editSelectedPlanDetails && this.vacantSeatPlanCodes.includes(this.editForm.plan)
    },
    // Plano grátis (Gerencial) não tem pró-rata nem pagamento: ativa direto, como o
    // convite gratuito.
    editActivatesFreePlan () {
      return this.editIsActivating &&
        !this.editActivatesVacantSeat &&
        !!this.editSelectedPlanDetails &&
        this.isFreePlanCode(this.editForm.plan)
    },
    editReleasesSeat () {
      return this.seatsDecoupled &&
        this.editForm.status === USER_STATUS.INACTIVE.label &&
        this.initialEditForm.status !== USER_STATUS.INACTIVE.label
    },
    gerencialPlanCode () {
      return PLAN_CODE_MANAGER
    },
    // Por código, não pela feature `nao-realiza-ligacoes`: o gêmeo `manager-ia4com`
    // também a tem, e o acerto dependia da ordem em que as ofertas voltavam.
    gerencialPlanName () {
      const plan = this.pricingList.find(p => p.code === PLAN_CODE_MANAGER)
      return plan ? plan.name : 'Gerencial'
    },
    showBillingColumns () {
      const organization = this.$store.state.auth.organization
      if (organization === null || organization === undefined) {
        return false
      }
      return organization.blockByPlan === true
    },
    inviteEligibilitySummaryMessage () {
      if (this.inviteEligibilityMaxUsers === null) return 'Sua conta possui limite de usuários.'
      return `Sua conta permite até ${this.inviteEligibilityMaxUsers} usuários.`
    },
    // Ativando um usuário (status → Ativo) numa conta de plano: dispara o preview
    // da pró-rata (mesmo cálculo do convite) antes de confirmar/gerar a cobrança.
    editIsActivating () {
      return this.isUnlimited &&
        this.editForm.status === 'Ativo' &&
        (this.initialEditForm.status || '') !== 'Ativo'
    },
    editSelectedPlanDetails () {
      if (!this.editForm.plan || this.pricingList.length === 0) return null
      const plan = this.pricingList.find(p => p.code === this.editForm.plan)
      if (!plan) return null
      const hasBoundedMinutes = plan.minutes != null && plan.minutes > 0
      return {
        name: plan.name,
        monthlyFee: Number(plan.monthlyFee),
        minutesLabel: hasBoundedMinutes ? `até ${plan.minutes} min` : null,
        benefits: planBenefitLabels(plan)
      }
    },
    // Plano atual do usuário editado é grátis (Gerencial): a licença dele não fica
    // livre ao sair, sai da assinatura (o billing a remove ao desocupar).
    editCurrentPlanIsFree () {
      return this.isFreePlanCode(this.editCurrentPlanCode)
    },
    editPlanBadgeStyle () {
      return getPlanBadgeStyle(this.editForm.plan)
    },
    // Troca de plano de um usuário JÁ ATIVO (status Ativo e já era Ativo) — upgrade
    // ou downgrade, decidido pelo preview do billing (mode UPSELL/DOWNSELL).
    editPlanChanged () {
      return (this.initialEditForm.plan || '') !== (this.editForm.plan || '')
    },
    editIsChangingPlan () {
      return this.isUnlimited &&
        this.editForm.status === 'Ativo' &&
        (this.initialEditForm.status || '') === 'Ativo' &&
        this.editPlanChanged
    },
    editChangePlanUsesVacantSeat () {
      return this.editIsChangingPlan &&
        !!this.editChangePlanPreview &&
        this.editChangePlanPreview.path === VACANT_SEAT_PATH
    },
    editIsUpgrade () {
      return this.editIsChangingPlan &&
        !!this.editChangePlanPreview &&
        this.editChangePlanPreview.mode === 'UPSELL' &&
        !this.editChangePlanUsesVacantSeat
    },
    // Cobrança pró-rata em aberto que a confirmação vai cancelar. Vem do preview
    // do fluxo em curso: a troca de plano de um usuário ativo e a ativação de um
    // que ficou aguardando pagamento geram a mesma substituição no billing.
    editPendingInvoice () {
      if (this.editIsUpgrade) return this.editChangePlanPreview.pendingInvoice
      if (this.editIsActivating && this.editProrataPreview) return this.editProrataPreview.pendingInvoice
      return null
    },
    editIsDowngrade () {
      return this.editIsChangingPlan &&
        !!this.editChangePlanPreview &&
        this.editChangePlanPreview.mode === 'DOWNSELL' &&
        !this.editChangePlanUsesVacantSeat
    },
    // Sem o preview resolvido não se sabe qual troca será feita: salvar cairia no
    // PATCH sem plano e responderia sucesso sem trocar nada.
    editPlanChangeBlocked () {
      if (this.editIsDowngrade) return true
      return this.editIsChangingPlan &&
        (this.editChangePlanLoading || !!this.editChangePlanError || !this.editChangePlanPreview)
    },
    // O que a confirmação vai cobrar de verdade. Até o TEL-2297 isto era a própria
    // diferença proporcional, e mostrar `proratedValue` no total não errava. Depois
    // que o billing passou a adiantar a mensalidade do ciclo já quitado, os dois
    // deixaram de ser a mesma coisa — e o total continuava mostrando a parcela menor,
    // então o operador confirmava um valor e o cliente recebia outro.
    //
    // O fallback para `proratedValue` deixa a ordem de deploy livre: contra um billing
    // que ainda não manda `totalValue`, a tela segue mostrando o que ele cobra.
    editChangePlanTotal () {
      const preview = this.editChangePlanPreview
      if (!preview) return 0
      if (preview.totalValue !== undefined && preview.totalValue !== null) {
        return Number(preview.totalValue)
      }
      return Number(preview.proratedValue)
    },
    // A parcela adiantada só é discriminada quando existe de fato. Troca de plano
    // normal — a esmagadora maioria — não vê esta linha.
    editChangePlanShowNextCycleFee () {
      const preview = this.editChangePlanPreview
      return !!preview &&
        preview.nextCycleAlreadyPaid === true &&
        Number(preview.nextCycleFee) > 0
    },
    // Plano atual do usuário sendo editado (valor mensal do seat na assinatura).
    editCurrentPlanValue () {
      if (!this.userToEdit) return null
      const data = this.userPlanData[this.userToEdit.id]
      return data && data.value != null ? Number(data.value) : null
    },
    // Usuário JÁ ativo (status Ativo e já era Ativo) — contexto de troca de plano.
    editIsActiveUser () {
      return this.editForm.status === 'Ativo' && (this.initialEditForm.status || '') === 'Ativo'
    },
    // Teto de minutos do plano atual do usuário. `null` = ilimitado, e é tratado como
    // infinito na comparação abaixo.
    editCurrentPlanMinutes () {
      if (!this.userToEdit) return undefined
      const data = this.userPlanData[this.userToEdit.id]
      if (!data || !data.planCode) return undefined
      const plan = this.pricingList.find(p => p.code === data.planCode)
      return plan ? plan.minutes : undefined
    },
    // Planos de UPGRADE de um usuário já ativo.
    //
    // Mais caro que o atual E sem reduzir o teto de minutos. O billing decide
    // UPSELL/DOWNSELL só por preço, então sem a segunda regra o cliente na Negociação
    // (300 min) veria Gerencial + IA4COM: mais caro, classificado como upgrade, e sem
    // realizar ligações. O "mais caro" também é o que garante que toda opção ofertada
    // volte como UPSELL — o pbxapi recusa DOWNSELL com 422.
    //
    // Exceção: ganhar o IA4COM mantendo ligações vale como upgrade mesmo com teto menor
    // (Ilimitado → Negociação + IA4COM). Sem ligar (Gerencial + IA4COM) continua fora.
    editAvailableUpgradePlans () {
      if (!this.editIsActiveUser || this.editCurrentPlanValue == null) return []
      const currentMinutes = this.editCurrentPlanMinutes
      const currentPlan = this.pricingList.find(plan => plan.code === this.editCurrentPlanCode)
      const currentHasIa4com = !!currentPlan && currentPlan.hasIa4com === true
      return this.pricingList.filter(plan => {
        if (Number(plan.monthlyFee) <= this.editCurrentPlanValue) return false
        if (currentMinutes === undefined) return true
        if (this.isMinutesCeilingAtLeast(plan.minutes, currentMinutes)) return true
        return plan.hasIa4com === true && !currentHasIa4com && plan.minutes !== 0
      })
    },
    // Planos que o dropdown mostra: na ativação, todos; no upgrade, os disponíveis.
    editSelectablePlans () {
      if (this.editIsActivating && this.editAwaitingCanTakeVacantSeat) {
        return this.pricingList.filter(plan => this.vacantSeatPlanCodes.includes(plan.code))
      }
      if (this.editIsActivating) return this.pricingList
      if (!this.editIsActiveUser) return []
      const currentPlanCode = this.editCurrentPlanCode
      return this.pricingList.filter(plan =>
        this.editAvailableUpgradePlans.includes(plan) ||
        (plan.code !== currentPlanCode && this.vacantSeatPlanCodes.includes(plan.code)))
    },
    editCurrentPlanCode () {
      if (!this.userToEdit) return null
      const data = this.userPlanData[this.userToEdit.id]
      return data ? data.planCode : null
    },
    // Usuário já ativo no plano mais alto (sem upgrade possível) → trava o dropdown.
    editUserAtMaxPlan () {
      return this.editIsActiveUser &&
        this.editCurrentPlanValue != null &&
        this.editSelectablePlans.length === 0
    },
    // Dropdown editável: na ativação (qualquer plano) e no upgrade de um ativo
    // (só quando há plano mais alto disponível — senão fica travado).
    editPlanDropdownEnabled () {
      if (this.editIsActivating) return true
      if (this.editIsActiveUser) return this.editSelectablePlans.length > 0
      return false
    },
    // Vira wizard (pró-rata + pagamento) na ativação e no upgrade.
    editIsWizard () {
      return (this.editIsActivating && !this.editActivatesVacantSeat && !this.editActivatesFreePlan) || this.editIsUpgrade
    },
    // Bloqueia o "Próximo" até o preview correspondente estar pronto.
    editStep1Blocked () {
      if (!this.editForm.plan) return true
      if (this.editIsUpgrade) {
        return this.editChangePlanLoading || !!this.editChangePlanError || !this.editChangePlanPreview
      }
      return this.editProrataLoading || !!this.editProrataError || !this.editProrataPreview
    }
  },
  mounted () {
    this.loadUsers()
    this.loadPricingList()
    this.primeInviteEligibilityCache()
    document.addEventListener('click', this.handleFilterClickOutside)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleFilterClickOutside)
  },
  methods: {
    formatSeatShortDay,
    formatSeatShortLastUsableDay,
    loadPricingList () {
      return loadAndMapOffers().then(list => {
        this.pricingList = list
      })
    },
    // Soma os minutos de uma lista de consumos, ignorando os indisponíveis.
    // Devolve null quando nenhum consumo é conhecido, para a UI exibir "—" em vez de "0 min".
    sumConsumption (consumptions) {
      const known = consumptions.filter(c => c && typeof c.current === 'number')
      if (known.length === 0) return null
      return known.reduce((sum, c) => sum + c.current, 0)
    },
    openAssignSeat (seat) {
      this.seatToAssign = seat
    },
    isInactiveUser (user) {
      return this.getUserStatus(user) === USER_STATUS.INACTIVE.key
    },
    isGerencialUser (user) {
      return !this.userPlanData[user.id] && this.getStatusLabel(user) === USER_STATUS.ACTIVE.label
    },
    // Código do plano do usuário. Quem não tem seat na assinatura e está ativo é
    // Gerencial por definição — é a mesma regra do `isGerencialUser`.
    getUserPlanCode (user) {
      const planData = this.userPlanData[user.id]
      if (planData && planData.planCode) return planData.planCode
      return this.isGerencialUser(user) ? PLAN_CODE_MANAGER : null
    },
    isOutOfMinutes (user) {
      const consumption = this.userConsumption[user.id]
      // limit null = ilimitado; limit 0 = gerencial (não realiza ligações) → não destaca.
      if (consumption === undefined || consumption.limit === null || consumption.limit === 0) return false
      // current null = consumo indisponível → não dá para afirmar estouro de franquia.
      if (consumption.current === null) return false
      return consumption.current >= consumption.limit
    },
    // Busca um trecho do /users. Formato `filter` como JSON stringificado (e não
    // `filter[chave]=`), que é o que o pbxapi espera e o mesmo padrão do filtro de
    // usuários do Dashboard.
    fetchUsersPage (skip, limit) {
      const filter = {
        // O desempate por uuid não é decoração: `name ASC` sozinho não define uma ordem
        // total, e com skip/limit dois homônimos podem trocar de posição entre duas
        // requisições — o que faz um usuário vir duas vezes e outro nunca vir.
        order: ['name ASC', 'uuid ASC'],
        limit,
        skip
      }
      return loopback.get(`/users?filter=${encodeURIComponent(JSON.stringify(filter))}`)
        .then(rawUsers => (Array.isArray(rawUsers) ? rawUsers : []))
    },
    // Percorre as páginas até a API devolver uma incompleta (acabou) ou até bater o teto.
    // Devolve { users, truncated } — truncated=true significa "a conta tem mais do que a
    // tela carregou", e a tela é obrigada a dizer isso ao usuário.
    fetchAllUsers () {
      const collected = []
      const fetchFrom = (page) => {
        return this.fetchUsersPage(page * USERS_PAGE_SIZE, USERS_PAGE_SIZE).then(list => {
          collected.push(...list)
          // Página incompleta => era a última, e a lista está completa.
          if (list.length < USERS_PAGE_SIZE) return { users: collected, truncated: false }
          if (page + 1 >= USERS_MAX_PAGES) {
            // Ter batido o teto não prova que há mais: numa conta com exatamente
            // USERS_MAX_PAGES × USERS_PAGE_SIZE usuários a lista está completa, e o aviso
            // de truncamento seria falso — o mesmo tipo de mentira sobre completude que
            // esta tela existe para corrigir. Um único registro além do que foi coletado
            // separa "acabou aqui" de "parei aqui"; custa uma requisição, e só em conta
            // que chega ao teto.
            return this.fetchUsersPage(collected.length, 1)
              .then(extra => ({ users: collected, truncated: extra.length > 0 }))
          }
          return fetchFrom(page + 1)
        })
      }
      return fetchFrom(0)
    },
    loadUsers () {
      this.isLoading = true
      this.error = null
      this.usersTruncated = false

      // Reset: userPlanData/userConsumption são chaveados por user.id, hoje resolvido a
      // partir do uuid. Sem limpar, ao convidar um usuário a lista é recarregada e as
      // entradas antigas sobrevivem — o que já custou caro quando a chave era posicional
      // (o novo usuário, awaiting_payment e sem assinatura, herdava plano e valor de quem
      // ocupava o índice antes, inflando o valor mensal). O F5 não mostrava isso porque
      // reinicializa esses objetos; aqui reproduzimos o F5.
      this.userPlanData = {}
      this.userConsumption = {}
      this.subscriptionNetValue = null

      return this.fetchAllUsers()
        .then(({ users: rawUsers, truncated }) => {
          // A chave da tela é o uuid, que o /users devolve para todo usuário. O fallback
          // posicional `user-${i}` continua por último só para não quebrar a renderização
          // num registro sem uuid, mas ele é justamente o caso que embaralha plano/valor
          // entre usuários — não é um caminho aceitável, é uma rede de segurança.
          const users = rawUsers.map((u, i) => ({ ...u, id: u.uuid || u.id || u._id || u.userId || `user-${i}` }))

          this.users = users
          this.usersTruncated = truncated
          if (!users || !users.length) return null
          return getSubscriptionContext()
        })
        .then((subscriptionContext) => {
          if (!subscriptionContext || !this.users || !this.users.length) return

          this.billingDay = subscriptionContext.billingDay
          this.subscriptionNetValue = subscriptionContext.netValue
          this.seats = subscriptionContext.seats
          this.seatsLoaded = true
          this.loadPendingSeatPurchase()

          const subscriptionByUserId = subscriptionContext.dataByUserId

          this.users.forEach((user) => {
            const subscription = user.uuid !== undefined && subscriptionByUserId[user.uuid] !== undefined ? subscriptionByUserId[user.uuid] : null

            if (subscription !== null) {
              this.$set(this.userPlanData, user.id, {
                plan: subscription.plan,
                planCode: subscription.planCode,
                value: subscription.value
              })
            }

            // CONSUMO DO CICLO — contenção: o cálculo de minutos por ramal era feito
            // baixando TODOS os CDRs do ciclo no browser (/calls paginado de 1000 em 1000),
            // o que gerava ~25 requisições e ~11 MB por carga da tela e estourava o rate
            // limit de /calls (429 derrubando a listagem inteira). Removido até existir uma
            // agregação por ramal no backend.
            // current: null = indisponível. NUNCA usar 0 aqui: é dado de cobrança e um zero
            // seria lido como "não consumiu". O limite continua vindo do /subscriptions.
            this.$set(this.userConsumption, user.id, {
              current: null,
              limit: subscription !== null ? subscription.limit : null
            })
          })
        })
        .catch((err) => {
          this.error = err
          console.error('Error loading users:', err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    applyFilters () {
      this.currentPage = 1
    },
    onPerPageChange () {
      this.currentPage = 1
    },
    sortBy (field) {
      if (this.sortField === field) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortField = field
        this.sortDirection = 'asc'
      }
    },
    getUserStatus (user) {
      const raw = user && user.status != null ? String(user.status).trim().toUpperCase().replace(/\s+/g, '_') : ''
      const key = API_TO_KEY[raw]
      return key !== undefined ? key : USER_STATUS.ACTIVE.key
    },
    getStatusLabel (user) {
      const status = this.getUserStatus(user)
      const label = KEY_TO_LABEL[status]
      return label !== undefined ? label : USER_STATUS.ACTIVE.label
    },
    getFormStatus (label) {
      if (!label || typeof label !== 'string') return USER_STATUS.ACTIVE.api
      const s = label.trim()
      const apiVal = LABEL_TO_API[s]
      if (apiVal !== undefined) return apiVal
      return s.toLowerCase() === USER_STATUS.AWAITING_PAYMENT.label.toLowerCase() ? USER_STATUS.AWAITING_PAYMENT.api : USER_STATUS.ACTIVE.api
    },
    getStatusClass (user) {
      const status = this.getUserStatus(user)
      if (status === USER_STATUS.ACTIVE.key) return 'badge badge-success'
      if (status === USER_STATUS.AWAITING_PAYMENT.key) return 'badge badge-warning'
      return 'badge badge-secondary'
    },
    hasPendingInvite (user) {
      if (this.isInactiveUser(user)) return false
      return !(user.emailVerified === true || user.emailVerified === 'true')
    },
    isCurrentUser (user) {
      const currentUser = this.$store.state.auth && this.$store.state.auth.user
      if (!currentUser || !user) return false
      // user.id da lista é o uuid; o /users/me devolve o model inteiro, onde `id` é a PK
      // interna e o uuid vem em `uuid`. Comparar com os dois: contra `id` sozinho isto
      // nunca batia e a identificação caía sempre no e-mail.
      const userId = user.id
      const currentUserId = currentUser.uuid || currentUser.id
      if (userId && currentUserId && String(userId) === String(currentUserId)) return true
      const userEmail = (user.email || '').toLowerCase().trim()
      const currentUserEmail = (currentUser.email || '').toLowerCase().trim()
      return !!userEmail && !!currentUserEmail && userEmail === currentUserEmail
    },
    formatUserCurrency (value) {
      return formatCurrency(value)
    },
    goToSubscription () {
      this.$router.push('/subscription')
    },
    goToChargeHistory () {
      this.$router.push('/charge/history')
    },
    async openAddUserModal () {
      this.inviteEligibilityBlockMessage = ''
      const eligibility = await this.fetchInviteEligibility(true)
      if (isAccountRestricted(eligibility)) {
        this.showAccountRestrictedModal = true
        return
      }
      if (this.isUnlimited) {
        this.showAddUserModal = true
        return
      }
      if (eligibility === null) {
        this.inviteEligibilityBlockMessage = 'Não foi possível validar a elegibilidade para convite agora. Tente novamente em instantes.'
        this.showUserLimitReachedModal = true
        return
      }
      if (typeof eligibility.isUnlimited === 'boolean' && eligibility.isUnlimited !== this.isUnlimited) {
        this.showSessionOutdatedModal = true
        return
      }
      if (eligibility.canInvite !== true) {
        this.showUserLimitReachedModal = true
        return
      }
      this.showAddUserModal = true
    },
    closeAddUserModal () {
      this.showAddUserModal = false
    },
    closeUserLimitReachedModal () {
      this.showUserLimitReachedModal = false
      this.inviteEligibilityBlockMessage = ''
    },
    confirmSessionOutdated () {
      this.showSessionOutdatedModal = false
      this.$store.dispatch('auth/signOut')
    },
    handleUserLimitUpgradeClick () {
      this.closeUserLimitReachedModal()
      this.goToSubscription()
    },
    primeInviteEligibilityCache () {
      if (this.isUnlimited) return
      this.fetchInviteEligibility()
    },
    async fetchInviteEligibility (forceRefresh = false) {
      const eligibility = await getInviteEligibility({ forceRefresh })
      if (!eligibility) return null
      this.cacheInviteEligibility(eligibility)
      return eligibility
    },
    cacheInviteEligibility (eligibility) {
      this.inviteEligibilityMaxUsers = resolveInviteEligibilityMaxUsers(eligibility)
      this.inviteEligibilityCutoffDate = eligibility ? eligibility.cutoffDate : null
      this.canInvite = eligibility && (eligibility.canInvite !== false || isAccountRestricted(eligibility))
    },
    isSeatCandidate (user) {
      const status = this.getUserStatus(user)
      return status === USER_STATUS.INACTIVE.key || status === USER_STATUS.AWAITING_PAYMENT.key
    },
    getUserSeat (user) {
      const seat = this.seats.find(candidateSeat => candidateSeat.userId === user.uuid)
      return seat === undefined ? null : seat
    },
    // Licença gratuita (Gerencial) não se transfere: ao sair, o billing a remove da
    // assinatura, e ocupar a mesma licença em seguida falharia com quem saiu já
    // desativado. Quem entra recebe o plano gratuito direto, sem cobrança.
    canTransferSeat (user) {
      const seat = this.getUserSeat(user)
      return this.canManageSeats &&
        !this.isCurrentUser(user) &&
        this.getUserStatus(user) === USER_STATUS.ACTIVE.key &&
        seat !== null &&
        !this.isFreePlanCode(seat.planCode)
    },
    isFreePlanCode (planCode) {
      const plan = this.pricingList.find(candidate => candidate.code === planCode)
      return !!plan && Number(plan.monthlyFee) === 0
    },
    transferSourceOf (user) {
      return {
        email: user.email,
        name: user.name ? user.name : user.email,
        seat: this.getUserSeat(user)
      }
    },
    openTransferSeatModal (user) {
      this.seatTransferSenderDeactivated = false
      this.seatTransferFrom = this.transferSourceOf(user)
    },
    loadPendingSeatPurchase () {
      if (!this.canManageSeats) return
      getPendingSeatPurchase()
        .then((pending) => { this.pendingSeatPurchase = pending })
        .catch((err) => {
          console.error('Erro ao buscar compra de licenças pendente:', err)
          this.pendingSeatPurchase = null
        })
    },
    async openPurchaseSeatsModal () {
      const eligibility = await this.fetchInviteEligibility(true)
      if (isAccountRestricted(eligibility)) {
        this.showAccountRestrictedModal = true
        return
      }
      this.showPurchaseSeatsModal = true
    },
    closePurchaseSeatsModal () {
      this.showPurchaseSeatsModal = false
      this.loadPendingSeatPurchase()
    },
    closeTransferSeatModal () {
      this.seatTransferFrom = null
      this.seatTransferSenderDeactivated = false
    },
    vacantSeatCount (planCode) {
      return this.vacantSeatPlanCodes.filter(vacantPlanCode => vacantPlanCode === planCode).length
    },
    viewUserDetails (user) {
      this.selectedUser = user
      this.showDetailsModal = true
    },
    closeDetailsModal () {
      this.showDetailsModal = false
      this.selectedUser = null
    },
    getUserRole (user) {
      if (user.role === 'ADMIN') return 'Administrador'
      if (user.role === 'USER') return 'Usuário'
      return user.role || 'Usuário'
    },
    getUserExtension (user) {
      if (!user || user.extension === undefined || user.extension === null) return null
      return String(user.extension).trim()
    },
    editUser (user) {
      this.closeDetailsModal()
      this.userToEdit = user

      this.editForm.status = this.getStatusLabel(user)
      this.editForm.accessType = this.getUserRole(user)

      // O plano atual só é exibido quando o Bloqueio por Consumo está ligado
      // (blockByPlan/showBillingColumns). Sem ele, o dropdown começa vazio e o
      // plano só é escolhido no contexto da ativação.
      const planData = this.userPlanData[user.id]
      this.editForm.plan = (this.showBillingColumns && planData) ? planData.planCode : ''

      this.initialEditForm = {
        status: this.editForm.status,
        accessType: this.editForm.accessType,
        plan: this.editForm.plan
      }

      this.showEditModal = true
    },
    closeEditModal () {
      this.showEditModal = false
      this.userToEdit = null
      this.closeAllDropdowns()
      this.editForm = {
        status: '',
        accessType: '',
        plan: ''
      }
      this.initialEditForm = {
        status: '',
        accessType: '',
        plan: ''
      }
      this.editStep = 1
      this.editProrataPreview = null
      this.editProrataError = null
      this.editProrataLoading = false
      this.editChangePlanPreview = null
      this.editChangePlanError = null
      this.editChangePlanLoading = false
      this.editSelectedPaymentMethod = 'credit_card'
      this.editContactValid = false
    },
    prepareInviteSentCard (user, showConfirmationLink) {
      this.inviteSentDisplayName = user.name || user.email || 'Usuário'
      this.inviteSentShortName = (user.name && user.name.trim().split(/\s+/)[0]) || (user.email && user.email.split('@')[0]) || this.inviteSentDisplayName
      this.inviteSentEmail = user.email || ''
      this.inviteSentShowConfirmationLink = showConfirmationLink
    },
    async saveAndShowInviteSent () {
      if (!this.userToEdit) return
      this.prepareInviteSentCard(this.userToEdit, this.editForm.status === 'Ativo')
      const transferableSeat = this.editReleasesSeat && this.canTransferSeat(this.userToEdit)
        ? this.transferSourceOf(this.userToEdit)
        : null
      const result = await this.saveUserChanges()
      this.inviteSentCardAccessTypeOnly = result.accessTypeOnly === true
      if (!this.error && result.shouldShowInviteSentCard) {
        this.deactivatedSeatTransfer = transferableSeat
        this.showInviteSentCard = true
      }
    },
    transferDeactivatedSeat () {
      const transferFrom = this.deactivatedSeatTransfer
      this.closeInviteSentCard()
      this.seatTransferSenderDeactivated = true
      this.seatTransferFrom = transferFrom
    },
    async resendInvite (user) {
      if (this.resendingInviteEmail) return
      this.resendingInviteEmail = user.email
      this.resendInviteError = ''
      try {
        await loopback.patch('/users', { email: user.email, emailVerified: 'false' })
        await loopback.patch('/users', { email: user.email, emailVerified: 'true' })
        this.prepareInviteSentCard(user, true)
        this.inviteSentCardAccessTypeOnly = false
        this.showInviteSentCard = true
      } catch (err) {
        console.error('Erro ao reenviar convite:', err)
        this.resendInviteError = 'Não foi possível reenviar o convite. Tente novamente.'
      } finally {
        this.resendingInviteEmail = ''
      }
    },
    closeInviteSentCard () {
      this.deactivatedSeatTransfer = null
      this.showInviteSentCard = false
      this.inviteSentCardAccessTypeOnly = false
      this.inviteSentShowConfirmationLink = false
      this.activationPaymentLink = ''
      this.activationChargeValue = null
      this.vacantSeatMessage = ''
    },
    closeAllDropdowns () {
      this.showStatusDropdown = false
      this.showAccessTypeDropdown = false
      this.showPlanDropdown = false
    },
    handleOverlayClick (event) {
      const modal = event.target.closest('.edit-user-modal')
      if (!modal) {
        return
      }
      const isDropdownButton = event.target.closest('.edit-dropdown-button')
      const isDropdownMenu = event.target.closest('.dropdown-menu')
      const isDropdownItem = event.target.closest('.dropdown-item')
      const isDropdown = event.target.closest('.dropdown')
      if (!isDropdownButton && !isDropdownMenu && !isDropdownItem && !isDropdown) {
        this.closeAllDropdowns()
      }
    },
    toggleStatusDropdown (event) {
      if (event) {
        event.stopPropagation()
      }
      if (this.editStatusLocked) return
      const newValue = !this.showStatusDropdown
      this.showStatusDropdown = newValue
      this.showAccessTypeDropdown = false
      this.showPlanDropdown = false
    },
    toggleAccessTypeDropdown (event) {
      if (event) {
        event.stopPropagation()
      }
      const newValue = !this.showAccessTypeDropdown
      this.showAccessTypeDropdown = newValue
      this.showStatusDropdown = false
      this.showPlanDropdown = false
    },
    togglePlanDropdown (event) {
      if (event) {
        event.stopPropagation()
      }
      // Plano editável quando o usuário está/ficará Ativo: ativação (Desativado →
      // Ativo) e upgrade de um usuário já ativo.
      if (!this.editPlanDropdownEnabled) return
      const newValue = !this.showPlanDropdown
      this.showPlanDropdown = newValue
      this.showStatusDropdown = false
      this.showAccessTypeDropdown = false
    },
    selectStatus (status) {
      this.editForm.status = status
      this.showStatusDropdown = false
      this.editStep = 1
      this.fetchEditPlanPreview()
    },
    goToEditStep2 () {
      if (this.editStep1Blocked) return
      this.editStep = 2
    },
    selectAccessType (accessType) {
      this.editForm.accessType = accessType
      this.showAccessTypeDropdown = false
    },
    selectPlan (plan) {
      this.editForm.plan = plan
      this.showPlanDropdown = false
      this.editStep = 1
      this.fetchEditPlanPreview()
    },
    // Compara tetos de minutos. `null` = ilimitado (vale como infinito); `0` = não
    // realiza ligações. Serve para não oferecer um plano mais caro que ligue menos.
    isMinutesCeilingAtLeast (candidateMinutes, currentMinutes) {
      if (candidateMinutes === null) return true
      if (currentMinutes === null) return false
      return Number(candidateMinutes) >= Number(currentMinutes)
    },
    // Decide qual preview buscar conforme o caso: ativação (pró-rata do convite)
    // ou troca de plano de um usuário já ativo (upsell/downsell).
    fetchEditPlanPreview () {
      if (this.editActivatesVacantSeat || this.editActivatesFreePlan) {
        this.editProrataPreview = null
        this.editProrataError = null
        this.editChangePlanPreview = null
        this.editChangePlanError = null
        return
      }
      if (this.editIsActivating) {
        this.editChangePlanPreview = null
        this.editChangePlanError = null
        return this.fetchEditProrataPreview()
      }
      if (this.editIsChangingPlan) {
        this.editProrataPreview = null
        this.editProrataError = null
        return this.fetchEditChangePlanPreview()
      }
      this.editProrataPreview = null
      this.editProrataError = null
      this.editChangePlanPreview = null
      this.editChangePlanError = null
    },
    // Preview da troca de plano de um usuário ativo (upsell/downsell) — retorna o
    // mode e o valor da diferença proporcional, sem criar cobrança.
    async fetchEditChangePlanPreview () {
      this.editChangePlanPreview = null
      this.editChangePlanError = null
      if (!this.editIsChangingPlan || !this.editForm.plan) return
      const planCode = this.editForm.plan
      this.editChangePlanLoading = true
      try {
        this.editChangePlanPreview = await loopback.get('/users/change-plan-preview', {
          params: { email: this.userToEdit.email, toPlanName: planCode }
        })
      } catch (err) {
        this.editChangePlanError = this.resolveProrataErrorMessage(err)
      } finally {
        this.editChangePlanLoading = false
      }
    },
    // Busca o preview da pró-rata da ativação (proxy ao billing via pbxapi),
    // mesmo cálculo da cobrança real. Só quando o usuário está sendo ativado.
    async fetchEditProrataPreview () {
      this.editProrataPreview = null
      this.editProrataError = null
      if (!this.editIsActivating || !this.editForm.plan || this.editActivatesFreePlan) return
      const planCode = this.editForm.plan
      this.editProrataLoading = true
      try {
        this.editProrataPreview = await loopback.get('/users/proration-preview', {
          params: { planName: planCode, email: this.userToEdit.email }
        })
      } catch (err) {
        this.editProrataError = this.resolveProrataErrorMessage(err)
      } finally {
        this.editProrataLoading = false
      }
    },
    resolveProrataErrorMessage (err) {
      // TEL-2243: resolve por codigo, nao por trecho de texto (ver AddUserModal).
      return friendlyPlainText(err, 'Não foi possível calcular a cobrança proporcional. Tente novamente.')
    },
    processUserSave (promise, opts) {
      const { shouldShowInviteSentCard } = opts
      return new Promise((resolve) => {
        promise
          .then((result) => {
            const isUserSaveResult = result && result.shouldShowInviteSentCard !== undefined
            if (isUserSaveResult) return resolve(result)
            this.closeEditModal()
            return this.loadUsers().then(() => resolve({ shouldShowInviteSentCard, accessTypeOnly: false }))
          })
          .catch((err) => {
            this.error = err
            console.error('Error saving user changes:', err)
            return resolve({ shouldShowInviteSentCard: false, accessTypeOnly: false })
          })
          .finally(() => {
            this.isSaving = false
          })
      })
    },
    applyUserChangesRechargeModel () {
      const accessTypeChanged = (this.initialEditForm.accessType || '') !== (this.editForm.accessType || '')
      const statusChanged = (this.initialEditForm.status || '') !== (this.editForm.status || '')
      const planChanged = (this.initialEditForm.plan || '') !== (this.editForm.plan || '')
      const shouldShowInviteSentCard = true
      const role = this.editForm.accessType === 'Administrador' ? 'ADMIN' : 'USER'
      const patchBody = {
        email: this.userToEdit.email,
        role
      }
      if (this.initialEditForm.status !== 'Aguardando pagamento') {
        patchBody.status = this.getFormStatus(this.editForm.status)
      }
      if (statusChanged && this.editForm.status === 'Ativo') {
        patchBody.status = USER_STATUS.ACTIVE.api
        patchBody.emailVerified = 'false'
      }
      // Conta de recarga não tem dropdown de plano (ele é `v-if="isUnlimited"`), então
      // na prática isto não dispara. Mantém o nome de exibição, que é o que este PATCH
      // sempre recebeu — `editForm.plan` agora guarda o código.
      if (this.editSelectedPlanDetails) patchBody.plan = this.editSelectedPlanDetails.name
      return loopback.patch('/users', patchBody)
        .then(() => {
          if (statusChanged && this.editForm.status === 'Ativo') {
            return loopback.patch('/users', { email: this.userToEdit.email, emailVerified: 'true' })
          }
        })
        .then(() => {
          this.closeEditModal()
          return this.loadUsers()
        })
        .then(() => {
          const accessTypeOnly = accessTypeChanged && !statusChanged && !planChanged
          return { shouldShowInviteSentCard, accessTypeOnly }
        })
    },
    patchUserAccessTypeOnly () {
      const role = this.editForm.accessType === 'Administrador' ? 'ADMIN' : 'USER'
      return loopback.patch('/users', {
        email: this.userToEdit.email,
        role
      })
        .then(() => {
          this.closeEditModal()
          return this.loadUsers()
        })
        .then(() => ({ shouldShowInviteSentCard: true, accessTypeOnly: true }))
    },
    applyUserChangesPlanModel () {
      const role = this.editForm.accessType === 'Administrador' ? 'ADMIN' : 'USER'
      const statusChanged = (this.initialEditForm.status || '') !== (this.editForm.status || '')

      // Ativação (upsell) em conta de plano: em vez de ativar direto, gera a
      // cobrança pró-rata do plano escolhido. O usuário fica AWAITING_PAYMENT e
      // vira ACTIVE ao pagar (mesmo caminho do convite).
      if (statusChanged && this.editActivatesVacantSeat) {
        return this.activateUserInVacantSeat(role)
      }
      if (statusChanged && this.editActivatesFreePlan) {
        return this.activateUserInFreePlan(role)
      }
      if (statusChanged && this.editForm.status === 'Ativo') {
        return this.activateUserWithPlan(role)
      }

      // Upgrade de um usuário JÁ ativo: gera a cobrança pró-rata da diferença e
      // retorna o link de pagamento (o seat migra ao pagar). Downgrade é bloqueado
      // no botão (mode DOWNSELL), então não chega aqui.
      if (this.editIsUpgrade) {
        return this.upgradeUserPlan(role)
      }

      if (this.editChangePlanUsesVacantSeat) {
        return this.changeUserPlanToVacantSeat(role)
      }

      if (this.editIsChangingPlan) {
        return Promise.reject(new Error('Não foi possível confirmar a troca de plano. Feche e abra o usuário de novo para recalcular.'))
      }

      const patchBody = {
        email: this.userToEdit.email,
        role
      }
      // Desativação (status → Inativo) dispara o downsell no pbxapi. A troca de
      // plano de um usuário ativo NÃO é feita pelo portal (só na ativação), então
      // não enviamos `plan` aqui.
      if (statusChanged) {
        patchBody.status = this.getFormStatus(this.editForm.status)
      }
      return loopback.patch('/users', patchBody)
    },
    async activateUserWithPlan (role) {
      // Abre a janela de pagamento de forma síncrona (antes de qualquer await) para
      // não ser bloqueada por popup blocker.
      const paymentWindow = window.open('', '_blank')
      let paymentWindowUsed = false
      try {
        // Persiste o contato de cobrança (e-mails financeiros + telefone) antes de gerar.
        // Em falha, mantém o modal aberto (o componente exibe o erro inline).
        const contact = this.$refs.editContactFields
        const ok = contact ? await contact.persist() : true
        if (!ok) return { shouldShowInviteSentCard: false }

        const accessTypeChanged = (this.initialEditForm.accessType || '') !== (this.editForm.accessType || '')
        if (accessTypeChanged) {
          await loopback.patch('/users', { email: this.userToEdit.email, role })
        }

        const planCode = this.editForm.plan
        if (!planCode) {
          throw new Error('Selecione um plano para ativar o usuário.')
        }

        const billingType = billingTypeForPaymentMethod(this.editSelectedPaymentMethod)
        const result = await loopback.post('/users/activate-with-plan', {
          email: this.userToEdit.email,
          planName: planCode,
          billingType
        })

        this.activationPaymentLink = (result && (result.paymentUrl || result.invoiceUrl || result.externalUrl)) || ''
        this.activationChargeValue = (result && result.value != null) ? result.value : null
        if (result.path === VACANT_SEAT_PATH) {
          this.vacantSeatMessage = `Usuário ativado numa licença livre do plano ${this.editSelectedPlanDetails.name} — sem cobrança.`
        }

        const link = typeof this.activationPaymentLink === 'string' ? this.activationPaymentLink.trim() : ''
        if (link && paymentWindow) {
          paymentWindow.opener = null
          paymentWindow.location.href = link
          paymentWindowUsed = true
        }
        return result
      } finally {
        if (paymentWindow && !paymentWindowUsed) paymentWindow.close()
      }
    },
    // Upgrade de um usuário já ativo: gera a cobrança pró-rata da diferença via
    // pbxapi (que recusa downgrade) e abre o link de pagamento. O seat migra ao pagar.
    async upgradeUserPlan (role) {
      const paymentWindow = window.open('', '_blank')
      let paymentWindowUsed = false
      try {
        const contact = this.$refs.editContactFields
        const ok = contact ? await contact.persist() : true
        if (!ok) return { shouldShowInviteSentCard: false }

        const accessTypeChanged = (this.initialEditForm.accessType || '') !== (this.editForm.accessType || '')
        if (accessTypeChanged) {
          await loopback.patch('/users', { email: this.userToEdit.email, role })
        }

        const planCode = this.editForm.plan
        if (!planCode) {
          throw new Error('Selecione um plano.')
        }

        const billingType = billingTypeForPaymentMethod(this.editSelectedPaymentMethod)
        const result = await loopback.post('/users/change-plan', {
          email: this.userToEdit.email,
          toPlanName: planCode,
          billingType
        })

        this.activationPaymentLink = (result && (result.paymentUrl || result.invoiceUrl || result.externalUrl)) || ''
        this.activationChargeValue = (result && result.value != null) ? result.value : null
        if (result.path === VACANT_SEAT_PATH) {
          this.vacantSeatMessage = this.changedToVacantSeatMessage()
        }

        const link = typeof this.activationPaymentLink === 'string' ? this.activationPaymentLink.trim() : ''
        if (link && paymentWindow) {
          paymentWindow.opener = null
          paymentWindow.location.href = link
          paymentWindowUsed = true
        }
        return result
      } finally {
        if (paymentWindow && !paymentWindowUsed) paymentWindow.close()
      }
    },
    async activateUserInVacantSeat (role) {
      const accessTypeChanged = (this.initialEditForm.accessType || '') !== (this.editForm.accessType || '')
      if (accessTypeChanged) {
        await loopback.patch('/users', { email: this.userToEdit.email, role })
      }
      const planSeats = this.vacantSeats.filter(seat => seat.planCode === this.editForm.plan)
      const [seat] = [
        ...planSeats.filter(planSeat => !isLeavingSeat(planSeat)),
        ...planSeats.filter(isLeavingSeat)
      ]
      const result = await occupySeat(this.userToEdit.email, seat.seatId)
      this.vacantSeatMessage = `Usuário ativado numa licença livre do plano ${this.editSelectedPlanDetails.name} — sem cobrança.`
      return result
    },
    async activateUserInFreePlan (role) {
      const accessTypeChanged = (this.initialEditForm.accessType || '') !== (this.editForm.accessType || '')
      if (accessTypeChanged) {
        await loopback.patch('/users', { email: this.userToEdit.email, role })
      }
      const result = await loopback.post('/users/activate-with-plan', {
        email: this.userToEdit.email,
        planName: this.editForm.plan
      })
      this.vacantSeatMessage = `Usuário ativado no plano ${this.editSelectedPlanDetails.name}, sem cobrança.`
      return result
    },
    async changeUserPlanToVacantSeat (role) {
      const accessTypeChanged = (this.initialEditForm.accessType || '') !== (this.editForm.accessType || '')
      if (accessTypeChanged) {
        await loopback.patch('/users', { email: this.userToEdit.email, role })
      }
      const result = await loopback.post('/users/change-plan', {
        email: this.userToEdit.email,
        toPlanName: this.editForm.plan
      })
      this.vacantSeatMessage = this.changedToVacantSeatMessage()
      return result
    },
    changedToVacantSeatMessage () {
      const previousSeat = this.editCurrentPlanIsFree
        ? 'A licença gratuita anterior saiu da assinatura.'
        : 'A licença anterior ficou livre para outra pessoa.'
      return `Plano trocado para ${this.editSelectedPlanDetails.name} numa licença livre — sem cobrança. ${previousSeat}`
    },
    saveUserChanges () {
      if (!this.userToEdit) return Promise.resolve({ shouldShowInviteSentCard: false })

      this.isSaving = true
      this.error = null
      const accessTypeChanged = (this.initialEditForm.accessType || '') !== (this.editForm.accessType || '')
      const statusChanged = (this.initialEditForm.status || '') !== (this.editForm.status || '')
      const planChanged = (this.initialEditForm.plan || '') !== (this.editForm.plan || '')
      const shouldShowInviteSentCard = true
      const opts = { shouldShowInviteSentCard }

      if (!this.isUnlimited) {
        return this.processUserSave(this.applyUserChangesRechargeModel(), opts)
      }
      if (accessTypeChanged && !statusChanged && !planChanged) {
        return this.processUserSave(this.patchUserAccessTypeOnly(), opts)
      }
      if (statusChanged || planChanged) {
        return this.processUserSave(this.applyUserChangesPlanModel(), opts)
      }
      return this.processUserSave(Promise.resolve(), opts)
    },

    selectAllStatuses () {
      this.filters.status.all = true
      this.filters.status.active = false
      this.filters.status.awaitingPayment = false
      this.filters.status.inactive = false
      this.applyFilters()
    },
    selectAllPlans () {
      this.filters.plans.all = true
      this.filters.plans.codes = []
      this.applyFilters()
    },
    togglePlan (planCode) {
      this.filters.plans.all = false
      const codes = this.filters.plans.codes
      const index = codes.indexOf(planCode)
      if (index === -1) {
        codes.push(planCode)
      } else {
        codes.splice(index, 1)
      }
      this.applyFilters()
    },
    isPlanFilterSelected (planCode) {
      return !this.filters.plans.all && this.filters.plans.codes.includes(planCode)
    },
    toggleStatus (key) {
      this.filters.status.all = false
      if (key === USER_STATUS.ACTIVE.key) {
        this.filters.status.active = !this.filters.status.active
      } else if (key === USER_STATUS.AWAITING_PAYMENT.key) {
        this.filters.status.awaitingPayment = !this.filters.status.awaitingPayment
      } else if (key === USER_STATUS.INACTIVE.key) {
        this.filters.status.inactive = !this.filters.status.inactive
      }
      this.applyFilters()
    },
    toggleStatusFilterOpen () {
      const isDropdownOpenAfterToggle = !this.showStatusFilterDropdown
      this.showStatusFilterDropdown = isDropdownOpenAfterToggle
      if (isDropdownOpenAfterToggle) this.showPlanFilterDropdown = false
    },
    togglePlanFilterOpen () {
      const isDropdownOpenAfterToggle = !this.showPlanFilterDropdown
      this.showPlanFilterDropdown = isDropdownOpenAfterToggle
      if (isDropdownOpenAfterToggle) this.showStatusFilterDropdown = false
    },
    handleFilterClickOutside (e) {
      const statusEl = this.$refs.statusFilterDropdownRef
      const planEl = this.$refs.planFilterDropdownRef
      const insideStatus = statusEl && statusEl.contains(e.target)
      const insidePlan = planEl && planEl.contains(e.target)
      if (!insideStatus) this.showStatusFilterDropdown = false
      if (!insidePlan) this.showPlanFilterDropdown = false
    }
  }
}
</script>

<style lang="scss" scoped>
.seats-tabs {
  display: flex;
  gap: 0.5rem;
  margin: 0 1.5rem 0.75rem 1.5rem;
}
.seats-tab {
  border: 1px solid #e5e7eb;
  background-color: #ffffff;
  color: #374151;
  border-radius: 0.5rem;
  padding: 0.375rem 0.875rem;
  font-size: 0.875rem;
  cursor: pointer;
}
.seats-tab--active {
  border-color: #2563eb;
  color: #1d4ed8;
  background-color: #eff6ff;
  font-weight: 600;
}

.users-list {
  .users-summary-upgrade-message {
    margin: 0;
    font-size: 0.8rem;
    line-height: 1.45;
    color: #64748b;
  }

  .users-summary-upgrade-link {
    color: #2563eb;
    font-weight: 500;
    margin-left: 0.15rem;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .plan-change-pending-disclaimer {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 0.625rem 1rem;
    margin-top: 1.25rem;
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 0.5rem;
  }

  .plan-change-pending-icon {
    flex-shrink: 0;
    color: #d97706;
    margin-top: 0.125rem;
  }

  .plan-change-pending-text {
    font-size: 0.8125rem;
    color: #92400e;
    line-height: 1.4;
    margin: 0;
  }

  .plan-change-pending-link {
    color: #92400e;
    font-weight: 600;
    text-decoration: underline;

    &:hover {
      color: #78350f;
    }
  }

  .plan-change-pending-link-icon {
    display: inline;
    vertical-align: middle;
    margin-left: 0.125rem;
  }

  .btn-invite-user {
    transition: background-color 0.2s ease;
    &:hover {
      background-color: #2058cf !important;
    }
  }

  .badge-success {
    background-color: #dcfce7;
    color: #166534;
  }

  .badge-warning {
    background-color: #fef3c7;
    color: #92400e;
  }

  .badge-secondary {
    background-color: #e5e7eb;
    color: #4b5563;
  }

  .search-input {
    transition: border-color 0.2s ease, box-shadow 0.2s ease, border-width 0.2s ease;

    &:focus {
      outline: none;
      border-color: #2563eb !important;
      border-width: 2px !important;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }
  }

  tr.user-row:has(.user-actions-dropdown.show) {
    position: relative;
    z-index: 1050;
  }
  .user-actions-cell {
    position: relative;
    z-index: 1;

    &:has(.user-actions-dropdown.show) {
      z-index: 1051;
    }
  }
  .user-actions-menu {
    z-index: 1052 !important;
  }
}

.user-details-modal {
  button:hover {
    opacity: 0.8;
  }

  button[style*="background-color: #ffffff"]:hover {
    background-color: #f9fafb !important;
  }

  button[style*="background-color: #2563eb"]:hover {
    background-color: #1d4ed8 !important;
  }
}

.edit-user-modal {
  overflow: visible !important;

  .btn-salvar-alteracoes {
    transition: background-color 0.2s ease;
    &:hover:not(:disabled) {
      background-color: #2058cf !important;
    }
  }

  .edit-dropdown-button {
    &:hover {
      border-color: #9ca3af !important;
    }

    &:focus {
      outline: none;
      border-color: #2563eb !important;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }
  }

  .dropdown {
    position: relative !important;

    .dropdown-menu {
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
      position: absolute !important;

      .dropdown-item {
        &:hover {
          background-color: #f9fafb;
        }
      }
    }
  }

  button:hover {
    opacity: 0.9;
  }

  button:disabled {
    cursor: not-allowed;
  }
}

.modal-overlay {
  .edit-user-modal {
    pointer-events: auto;
    overflow: visible !important;
  }
}

.pagination-container {
  position: relative;
  border-top: 1px solid rgba(229, 231, 235, 0.5);
  margin-top: 0 !important;
  padding: 1rem 1.5rem 1.5rem 1.5rem;

  transition: border-color 0.2s ease;
}

.pagination-layout {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;

  .per-page-selector {
    flex: 0 0 auto;
  }

  .pagination-center {
    flex: 1 1 auto;
    min-width: 0;
    text-align: center;
    color: #6b7280;
    font-size: 0.875rem;
  }
}

.per-page-selector {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.per-page-label {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 400;
  color: #9ca3af;
  line-height: 2rem;
  white-space: nowrap;
}

.per-page-dropdown {
  min-width: 4.5rem;
  height: 2rem;
  padding: 0 0.5rem 0 0.75rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: #374151;
  line-height: 1.25;
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  padding-right: 1.75rem;
  transition: border-color 0.15s ease, background-color 0.15s ease;
  vertical-align: middle;

  &:hover {
    background-color: #f3f4f6;
    border-color: #d1d5db;
  }

  &:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
  }
}

.dropdown--status-filter,
.dropdown--plan-filter {
  position: relative;

  .dropdown-menu {
    display: none;
  }
}

.dropdown--status-filter.dropdown--status-filter-open .dropdown-menu,
.dropdown--plan-filter.dropdown--plan-filter-open .dropdown-menu {
  display: block !important;
}

.status-filter-dropdown,
.plan-filter-dropdown {
  .filter-dropdown-option {
    padding: 0.5rem;
    cursor: pointer;
    border-radius: 0.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: transparent;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #f3f4f6;
    }
  }

  .filter-dropdown-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 50%;
    border: 2px solid #2563eb;
    background-color: transparent;
    transition: background-color 0.15s;

    &--blue.filter-dropdown-check--checked {
      background-color: #2563eb;
    }

    &--checked .filter-dropdown-check-icon {
      color: #fff;
    }
  }

  .filter-dropdown-check-icon {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
    color: transparent;
  }

  .filter-dropdown-label {
    font-size: 0.875rem;
    color: #374151;
  }

  .filter-dropdown-divider {
    height: 1px;
    background-color: #e5e7eb;
    margin: 0.25rem 0;
  }
}

.status-filter-dropdown .status-tag.status-tag-active:hover {
  background-color: #dcfce7;
  color: #15803d;
  border-color: #86efac;
}

.user-row--awaiting {
  background-color: #fffbeb !important;
}
.user-row--awaiting:hover {
  background-color: #fef3c7 !important;
}
.user-row--inactive {
  opacity: 0.85;
  td {
    color: #9ca3af !important;
    .lv-text-gray-800,
    .lv-text-gray-500,
    .lv-font-medium,
    .lv-text-sm {
      color: #9ca3af !important;
    }
    &.value-cell {
      color: #22c55e !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Users/List.vue